webpackJsonp([1],{

/***/ "5PDQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8csR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BZcA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GdIk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02796314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("oXGk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2d63fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("jsA2")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-b2d63fc6"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17839703","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.link))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("BZcA")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-17839703"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562d7af2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("8csR")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea834c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("vvnJ")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cad3ed6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("GdIk")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd893e96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("UhHM")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36934d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("UxE6")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b767d08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("UrMh")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-405171cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("aKuC")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-405171cd"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd40fbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("TKcf")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa23382e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("kxw3")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7504e64e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("5PDQ")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Escrime XII - Issue 120",
  "shortTitle": "",
  "description": "",
  "width": 1173,
  "height": 880,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://escrime-xxi.fie.org/120/en/"
  }, {
    code: "FR",
    text: "French",
    href: "https://escrime-xxi.fie.org/120/fr/"
  }, {
    code: "ES",
    text: "Spanish",
    href: "https://escrime-xxi.fie.org/120/es/"
  }],
  "basePath": "/120/en",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://escrime-xxi.fie.org/120/en/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '/120/en/static/_content/escrime-120-en.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": true,
    "guideEnabled": false
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 1-title\" style=\"top:84px;left:52px;\" src=\"/120/en/static/_content/1-title-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:210px;left:52px;\" src=\"/120/en/static/_content/1-title-2.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:1px;left:290px;\" src=\"/120/en/static/_content/1-numerals-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:84px;left:824px;\" src=\"/120/en/static/_content/1-ed-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:84px;left:957px;\" src=\"/120/en/static/_content/logo.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:328px;left:50px;\" src=\"/120/en/static/_content/1-sub-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:433px;left:53px;\" src=\"/120/en/static/_content/1-sub-2.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:499px;left:54px;\" src=\"/120/en/static/_content/1-sub-3.png\">\n      ",
    "mobileHtml": "\n        <img src=\"/120/en/static/_content/1-mobile-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n            .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n      \n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "N˚120 DIGITAL MAGAZINE  FÉDÉRATION INTERNATIONALE D’ESCRIME  Junior and Cadet World Championships World Cup Grand Prix  Use your keyboard keys, or swipe to navigate left and right through the magazine"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 2-title\" style=\"top:63px;left:64px;\" src=\"/120/en/static/_content/2-title-1.png\">\n        <img class=\"abs halfScale pointer howto-desktop\" style=\"top:96px;left:696px;\" onclick=\"switchPopHowto(true)\"\n          src=\"/120/en/static/_content/2-btn-1.png\">\n        <img class=\"abs halfScale pointer howto-ipad\" style=\"top:96px;left:850px;opacity:0\" onclick=\"switchPopHowto(false)\"\n          src=\"/120/en/static/_content/2-ipad-btn.png\">\n        <img class=\"abs halfScale 2-img howto-desktop\" style=\"top:202px;left:64px;\" src=\"/120/en/static/_content/2-img-1.png\">\n        <img class=\"abs halfScale 2-img howto-ipad\" style=\"top:191px;left:64px; opacity:0\" src=\"/120/en/static/_content/2-ipad.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:605px;left:39px;\" src=\"/120/en/static/_content/2-text-1.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:606px;left:220px;\" src=\"/120/en/static/_content/2-text-2.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:606px;left:508px;\" src=\"/120/en/static/_content/2-text-3.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:606px;left:776px;\" src=\"/120/en/static/_content/2-text-4.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim\n            .staggerFromTo(cOf(\"2-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1)\n        }\n\n        function switchPopHowto(bool){\n          if(bool){\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-ipad\")[0].style.opacity = 0;\n              cOf(\"howto-ipad\")[1].style.display = \"none\";\n            }});\n            cOf(\"howto-desktop\")[0].style.opacity = 1;\n            cOf(\"howto-desktop\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:1});\n          }else{\n            cOf(\"howto-ipad\")[0].style.opacity = 1;\n            cOf(\"howto-ipad\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:1});\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-desktop\")[0].style.opacity = 0;\n              cOf(\"howto-desktop\")[1].style.display = \"none\";\n            }});\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          resetNumbers(\"2-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "HOW TO USE  Click to change view  HOW TO USE Escrime XXI The Fencing Magazine uses the latest digital technology - here are some of the exciting features to enjoy.  DESKTOP  IPAD  SP ORT  MEN'S AND WOMEN'S EPEE GRAND PRIX IN BUDAPEST BUDAPEST, HUNGARY 4–6 MARCH 2022  BROWSING Use the arrows on your keypad to navigate horizontally through the magazine  Navigation To view the magazine, use the arrows on your keypad to travel left and right through the publication.  BROWSER For the best results, we recommend using Safari or Google Chrome  EXPLORE  e.. Hotspots insid  .  1 2 3 POP UPS  PLAY BUTTON  SOCIAL MEDIA  NUMBERS  Press to reveal, and hide, nuggets of information.  This magazine features great video. Pushing this will launch one.  Press the social media icons found throughout the magazine  Push the buttons to reveal more exciting content.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.absolutefencinggear.com/\" target=\"_blank\" class=\"contentLinkNone\" style=\"    top: 720px; left: 430px; width: 710px; height: 60px;\"></a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.absolutefencinggear.com/\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/3-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 4-title\" style=\"top:62px;left:63px;\" src=\"/120/en/static/_content/4-title-1.png\">\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC abs halfpulse animatedpulse\" style=\"top: 47px; left:644px;\" src=\"/120/en/static/_content/fb-navy.png\">\n        </a>\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC abs halfpulse animatedpulse\" style=\"top: 86px; left:644px;\" src=\"/120/en/static/_content/tw-navy.png\">\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n        <img id=\"4-next\" class=\"halfScale pointer\" style=\"top:719px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-sky.png\">\n\n          <img class=\"cont-item cont-item-1-btn halfScale\" style=\"top:250px;left:439px;opacity:0;\"\n              src=\"/120/en/static/_content/4-popup-1-1.png\">\n          <img class=\"cont-item cont-item-2-btn halfScale\" style=\"top:259px;left:440px;opacity:0\"\n            src=\"/120/en/static/_content/4-popup-2-1.png\">\n          <img class=\"cont-item cont-item-3-btn halfScale\" style=\"top:259px;left:440px;opacity:0\"\n            src=\"/120/en/static/_content/4-popup-2-2.png\">\n          <img class=\"cont-item cont-item-4-btn halfScale\" style=\"top:204px;left:440px;opacity:0\"\n            src=\"/120/en/static/_content/4-popup-3-1.png\">\n          <img class=\"cont-item cont-item-5-btn halfScale\" style=\"top:269px;left:440px;opacity:0\"\n            src=\"/120/en/static/_content/4-popup-4-1.png\">\n          <img class=\"cont-item cont-item-6-btn halfScale\" style=\"top:204px;left:440px;opacity:0\"\n            src=\"/120/en/static/_content/4-popup-5-1.png\">\n          <img class=\"cont-item cont-item-7-btn halfScale\" style=\"top:251px;left:440px;opacity:0\"\n            src=\"/120/en/static/_content/4-popup-6-1.png\">\n          \n          <div class=\"addContentLink\" onclick=\"contentsBub(1);\" style=\"top: 275px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(2);\" style=\"top: 345px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"contentLinkNone 2-click\" onclick=\"contentsBub(2);\"\n          style=\"top: 715px; left: 496px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 3-click\" onclick=\"contentsBub(2);\"\n          style=\"top: 715px; left: 496px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 2-click\" onclick=\"contentsBub(3);\"\n            style=\"top: 715px; left: 688px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 3-click\" onclick=\"contentsBub(3);\"\n            style=\"top: 715px; left: 688px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(4);\" style=\"top: 415px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(5);\" style=\"top: 486px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(6);\" style=\"top: 556px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(7);\" style=\"top: 626px; left: 65px; width: 377px; height: 50px;\"></div>\n          \n          <div class=\"contentLink cont-item-1-link\" onclick=\"Publish.goToPage(6)\"\n            style=\"top: 273px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(8)\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(10)\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(14)\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(17)\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(20)\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(22)\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(25)\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(27)\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(31)\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(33)\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(35)\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(39)\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(45)\"\n            style=\"top: 415px; left: 442px; width: 590px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-5-link\"\n            onclick=\"Publish.goToPage(47)\"\n            style=\"top: 486px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-1'), 1000})\"\n            style=\"top: 556px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-2'), 1000})\"\n            style=\"top: 626px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-1', '53-cta-1'), 1000})\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-2', '53-cta-2'), 1000})\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-3', '53-cta-3'), 1000})\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-4', '53-cta-4'), 1000})\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-5', '53-cta-5'), 1000})\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-6', '53-cta-6'), 1000})\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim\n            .fromTo(cOf(\"4-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"4-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function contentsBub(index){\n          console.log(index)\n          for(var i=0; i <= 9; i++){\n            if(i == index){\n              [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                c.style.display = \"\";\n              },0);\n              [].slice.call(cOf(i+\"-click\")).reduce(function(p,c){\n                c.style.display = \"\";\n              },0);\n              TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0, {opacity:1, onComplete:function(){\n                \n                cOf(\"cont-item-\"+index+\"-link\")[0].style.display = \"\"\n                if(cOf(\"cont-item-\"+index+\"-link\")[1]){\n                  cOf(\"cont-item-\"+index+\"-link\")[1].style.display = \"\" \n                }\n              }});\n            }else{\n              [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                  c.style.display = \"none\";\n                },0);\n              [].slice.call(cOf(i+\"-click\")).reduce(function(p,c){\n                  c.style.display = \"none\";\n                },0);\n              TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0, {opacity:0});\n            }\n          }\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          resetNumbers(\"4-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "THIS ISSUE  Welcome to the latest edition of Escrime XXI, packed with the best fencing images, video and features and showcased in a striking new look.  WWW.FIE.ORG  EDITORIAL  SPORT  Tap buttons to reveal content  FIE NEWS N˚120  CONFEDERATION AND FEDERATION NEWS  DIGITAL MAGAZINE  FÉDÉRATION INTERNATIONALE D’ESCRIME  WORLD NEWS  Junior and Cadet World Championships World Cup Grand Prix  ORBITUARIES Use your keyboard keys, or swipe to navigate left and right through the magazine  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:info@fie.ch\">\n          <div class=\"contentLink\" style=\"bottom: 170px; right: 526px; width: 124px; height: 21px;\"></div>\n        </a>\n        <a href=\"http://www.touchline.com\" target=\"_blank\">\n          <div class=\"contentLink\" style=\"    bottom: 178px; right: 236px; width: 234px; height: 21px;\"></div>\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLink\" style=\"bottom: 146px; right: 568px; width: 82px; height: 21px;\"></div>\n        </a>\n\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:775px;left:41px\"\n            src=\"/120/en/static/_content/tw-white.png\">\n        </a>\n\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:775px;left:94px\"\n            src=\"/120/en/static/_content/fb-white.png\">\n        </a>\n\n        <a href=\"https://www.youtube.com/user/FIEvideo\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:775px;left:147px\"\n            src=\"/120/en/static/_content/yt-white.png\">\n        </a>\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <img id=\"5-next\" class=\"halfScale pointer\" style=\"top:653px;right:-80px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-sky.png\">\n      ",
    "mobileHtml": "\n        <p><strong>Interim President:</strong><br>Emmanuel Katsiadakis (M.H.) (GRE)\n          <br><strong>Secretary Treasurer:</strong><br>Ferial Nadira Salhi (ALG)\n        </p>\n        <p><strong>Vice Presidents:</strong><br>Erika Aze (LAT)<br>Ana Irene Delgado\n          Guerra (PAN)<br>Abdelmoneim Elhamy El Husseiny (EGY)</p>\n        <p><strong>Members:</strong><br>Rusni Abu Hassan (MAS)<br>Donald Anthony Jr.\n          (USA)<br>Paolo Azzi (ITA)<br>Bruno Gares (FRA)<br>Vadym Guttsait\n          (UKR)<br>Velichka Hristeva (BUL)<br>Yuki Ota (JPN)<br>Novak Perovic\n          (RSA)<br>Oleg Peskov (KAZ)<br>Haibin Wang (CHN)<br>Aldo Montano President of\n          the FIE Athletes\u2019 Commission (ITA)</p>\n        <p><strong>President, African Fencing Confederation:</strong><br>Mbagnick Ndiaye\n          (SEN)<br><strong>President, Pan-American Fencing\n            Confederation:</strong><br>Vitaly Logvin (MEX)<br><strong>President, Asian\n            Fencing Confederation:</strong><br>HH. Engr. Sheikh Salem Sultan S. Al\n          Qasimi<br><strong>President, European Fencing\n            Confederation:</strong><br>Stanislav Pozdnyakov (RUS)\n          <br><strong>President, Oceanian Fencing Confederation:</strong><br>Helen Smith\n          (M.H.) (AUS)\n        </p>\n        <h2 id=\"fie-head-office\">FIE Head Office</h2>\n        <p><strong>Chief Executive Officer</strong><br>Nathalie Rodriguez M.-H. (FRA)\n        </p>\n        <h2 id=\"administration\">Administration</h2>\n        <p><strong>Administration Director:</strong><br>Elena Murdaca\n          (ITA)<br><strong>Accounting Manager:</strong><br>Sandra Baroni\n          (SUI)<br><strong>Administrative Assistant:</strong><br>Ylenia Murdaca\n          (ITA)<br><strong>Project Manager:</strong><br>Ekaterina Mashina (RUS)</p>\n        <h2 id=\"sport\">Sport</h2>\n        <p><strong>Sport and Technical Director:</strong><br>Evgeny Tsoukhlo\n          (RUS)<br><strong>Sport Technology and Administration\n            Manager:</strong><br>Natalia Bodrova (RUS)<br><strong>Head of\n            Operations:</strong><br>Elena Huot (RUS)</p>\n        <h2 id=\"communication-marketing-tv\">Communication, Marketing, TV</h2>\n        <p><strong>Head of FIE President\u2019s Cabinet:</strong><br>Nina Lalovic\n          (SRB)<br><strong>Digital Communications Manager:</strong><br>Maria Ntanou\n          (GRE)<br><strong>Head of FIE TV Production:</strong><br>Barna Heder\n          (HUN)<br><strong>FIE TV Production Assistant:</strong><br>Svetlana\n          Krasnokoutskaya (RUS)<br><strong>Press Officer:</strong><br>Serge Timacheff\n          (USA)<br><strong>Photographer:</strong><br>Augusto Bizzi (ITA)</p>\n        <h2 id=\"design\">Design</h2>\n        <p>Touchline (www.touchline.com)</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim\n            .fromTo(idOf(\"5-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          resetNumbers(\"5-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LIST OF C OME X  FIE HEAD OFFICE  Interim President: Emmanuel Katsiadakis (M.H.) (GRE) Secretary Treasurer: Ferial Nadira Salhi (ALG)  Chief Executive Officer Nathalie Rodriguez M.-H. (FRA)  Vice Presidents: Erika Aze (LAT) Ana Irene Delgado Guerra (PAN) Abdelmoneim Elhamy El Husseiny (EGY) Members: Rusni Abu Hassan (MAS) Donald Anthony Jr. (USA) Paolo Azzi (ITA) Bruno Gares (FRA) Vadym Guttsait (UKR) Velichka Hristeva (BUL) Yuki Ota (JPN) Novak Perovic (RSA) Oleg Peskov (KAZ) Haibin Wang (CHN) Aldo Montano President of the FIE Athletes’ Commission (ITA) President, African Fencing Confederation: Mbagnick Ndiaye (SEN) President, Pan-American Fencing Confederation: Vitaly Logvin (MEX) President, Asian Fencing Confederation: HH. Engr. Sheikh Salem Sultan S. Al Qasimi President, European Fencing Confederation: Stanislav Pozdnyakov (RUS) President, Oceanian Fencing Confederation: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Administration  Administration Director: Elena Murdaca (ITA) Accounting Manager: Sandra Baroni (SUI) Administrative Assistant: Ylenia Murdaca (ITA) Project Manager: Ekaterina Mashina (RUS) Sport  Sport and Technical Director: Evgeny Tsoukhlo (RUS)  Sport Technology and Administration Manager: Natalia Bodrova (RUS) Head of Operations: Elena Huot (RUS) Communication, Marketing, TV  Head of FIE President’s Cabinet: Nina Lalovic (SRB)  Digital Communications Manager: Maria Ntanou (GRE)  Head of FIE TV Production: Barna Heder (HUN)  FIE TV Production Assistant: Svetlana Krasnokoutskaya (RUS) Press Officer: Serge Timacheff (USA) Photographer: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img id=\"6-img\" class=\"halfScale 6-text-1 6-text\" style=\"top:168px;left:367px\"\n          src=\"/120/en/static/_content/6-img-1.png\">\n        <img id=\"6-title\" class=\"halfScale 6-title 6-text-1 6-text\" style=\"top:511px;left:297px\"\n          src=\"/120/en/static/_content/6-title-1.png\">\n        \n        <img id=\"6-text-1\" class=\"halfScale 6-text-1 6-text\" style=\"top:167px;left:601px\"\n          src=\"/120/en/static/_content/6-text-1.png\">\n        <img id=\"6-text-2\" class=\"halfScale 6-text-2 6-text\" style=\"top:167px;left:155px; opacity:0;\"\n          src=\"/120/en/static/_content/6-text-2.png\">\n        \n        <img id=\"6-cta-1\" class=\"halfScale pointer 6-btn\" style=\"top: 648px; left: 599px;transform: scale(0.505);\"\n          onclick=\"toggleText6(false);\" src=\"/120/en/static/_content/6-btn-1.png\">\n        <img id=\"6-cta-2\" class=\"halfScale pointer 6-btn\" style=\"top: 648px; left: 813px;transform: scale(0.505);opacity:0\"\n          onclick=\"toggleText6(true);\" src=\"/120/en/static/_content/6-btn-2.png\">\n\n        <img id=\"6-next\" class=\"halfScale pointer\" style=\"top:719px;right:-80px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-navy.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <h2 id=\"together-we-are-fencing\">Together We Are fencing</h2>\n        <img src=\"/120/en/static/_content/6-mobile-1.jpg\">\n        <p><strong>Dear Friends,</strong></p>\n        <p>We are pleased to bring you this issue of Escrime, covering a world of\n          fencing that is once again thriving globally. In this extremely difficult\n          time, the FIE expresses the wish that peace will prevail once again in the\n          world and we as a global family must come together to help those most in need.\n          Sport is a powerful tool for building peace, reconciliation and understanding\n          to bring people together. We can and should live peacefully. </p>\n        <p>We have also had to contend with the worldwide pandemic for the past two\n          years. During this period, the FIE and national federations worked to ensure\n          our events could go ahead as safely as possible. As a result, both World Cup\n          and Grand Prix competitions successfully began and will continue throughout\n          the year, with many events still to come. Likewise, we have just completed the\n          2022 Junior and Cadet Fencing World Championships in Dubai, where 1357 fencers\n          from 103 countries\u2014more than ever in our history\u2014gathered for nine days of\n          peaceful yet exciting competition. </p>\n        <p>Next, the Senior Fencing World Championships will be hosted in Egypt in July\n          and Croatia will welcome the Veteran Fencing World Championships in October.\n        </p>\n        <p>Following the resounding success of fencing at the Tokyo 2020 Olympic Games,\n          I believe we are in as strong a position as ever to carry on building our\n          strategy to further develop and increase its popularity with a view of the\n          Paris 2024 Olympic Games. The remarkable growth fencing has witnessed on\n          social media, television and in global participation clearly shows we are on\n          the right path to further develop our sport.</p>\n        <p>Now is the time to become resourceful and innovative to build fencing at many\n          levels to generate excitement and heighten awareness worldwide. We must\n          continue the momentum of past years to evolve forward with strength,\n          enthusiasm and optimism. </p>\n        <p>I invite all of you to embrace your roles as ambassadors and stakeholders in\n          our sport to become even stronger and more prominent, both in your communities\n          and your fencing halls. Whether you are an athlete, coach, official, volunteer\n          or fan, you each play a hugely significant role in the success of world\n          fencing that simply cannot be understated. </p>\n        <p>On behalf of the FIE, I would like to thank you for your continued support\n          and hope you enjoy a healthy and prosperous 2022.</p>\n        <p>Emmanuel Katsiadakis<br><strong>Interim President</strong></p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim\n            .fromTo(cOf(\"6-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"6-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function toggleText6(bool){\n          var text1 = idOf(\"6-text-1\");\n          var text2 = idOf(\"6-text-2\");\n          \n          if(!bool && text1.style.opacity == \"0\"){\n            pg6Anim.play();\n            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:0}, {opacity:1});\n          }else if(bool && text2.style.opacity == \"0\"){\n            pg6Anim.pause();\n            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:1}, {opacity:0});\n          }\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          resetNumbers(\"6-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "FORE WORD  Dear Friends, We are pleased to bring you this issue of Escrime, covering a world of fencing that is once again thriving globally. In this extremely difficult time, the FIE expresses the wish that peace will prevail once again in the world and we as a global family must come together to help those most in need. Sport is a powerful tool for building peace, reconciliation and understanding to bring people together. We can and should live peacefully.  TOGETHER WE ARE FENCING  We have also had to contend with the worldwide pandemic for the past two years. During this period, the FIE and national federations worked to ensure our events could go ahead as safely as possible. As a result, both World Cup and Grand Prix competitions successfully began and will continue throughout the year, with many events  PAGE 1  PAGE 2  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://shop.pbtfencing.com/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 21px; right: 723px; width: 193px; height: 38px;\"></div>\n        </a>\n        <a href=\"mailto:sales@pbtfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:21px;right:505px;width:205px;height:38px;\"></div>\n        </a>\n        <a href=\"https://www.instagram.com/pbt_fencing\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 21px; right: 259px; width: 236px; height: 38px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://shop.pbtfencing.com/\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/7-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top:127px;left:65px;\" src=\"/120/en/static/_content/8-title-1.png\">\n        <img class=\"abs halfScale 8-sub\" style=\"top:326px;left:97px;\" src=\"/120/en/static/_content/8-sub-1.png\">\n        <img class=\"abs halfScale 8-line\" style=\"top:324px;left:64px;\" src=\"/120/en/static/_content/8-line-1.png\">\n        <img id=\"8-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"usa-s-gassner-italy-s-cammilletti-win-tashkent-satellite-foil-tournament\">\n          USA\u2019s Gassner, Italy\u2019s Cammilletti win Tashkent Satellite Foil Tournament</h2>\n          <img src=\"/120/en/static/_content/8-mobile-1.jpg\">\n        <p><strong>Tashkent, Uzbekistan<br>29 September 2021</strong></p>\n        <p><strong>USA\u2019s Ethan Gassner and Italy\u2019s Marta Cammilletti won individual\n            men\u2019s and women\u2019s gold medals at the International Satellite Foil Tournament\n            in Tashkent, Uzbekistan, which took place on September 25 \u2013 26.</strong></p>\n        <p>Forty-eight athletes from multiple countries participated, including Belarus,\n          Iran, Iraq, Italy, Kazakhstan, Philippines, Turkey, USA and Uzbekistan.</p>\n        <p>In individual men\u2019s foil, Gassner won against Belarus\u2019 Uladzislau Kurylovich,\n          15-10. Bronze medals went to Akhmadillokhon Solikhojiev (UZB) and Mukhammad\n          Yusuf Asranov (UZB). </p>\n        <p>In individual women\u2019s foil, Cammilletti won against the Philippines\u2019 Maxine\n          Isabel Esteban, 15-2. Bronze medals went to Madinabonu Parpieva (UZB) and\n          Umida Ilyosova (UZB).</p>\n        <p>The event was held in accordance with FIE rules and COVID-19 protocol.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim\n            .fromTo(cOf(\"8-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"8-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"8-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"8-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          resetNumbers(\"8-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  USA’S GASSNER, ITALY’S CAMMILLETTI WIN TASHKENT SATELLITE FOIL TOURNAMENT TASHKENT, UZBEKISTAN 29 SEPTEMBER 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"9-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim\n            .fromTo(idOf(\"9-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n          resetNumbers(\"9-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "INTERNATIONAL SATELLITE FOIL TOURNAMENT TASHKENT, UZBEKISTAN 2 OF 2  USA’s Ethan Gassner and Italy’s Marta Cammilletti won individual men’s and women’s gold medals at the International Satellite Foil Tournament in Tashkent, Uzbekistan, which took place on September 27 – 26. Forty-eight athletes from multiple countries participated, including Belarus, Iran, Iraq, Italy, Kazakhstan, Philippines, Turkey, USA and Uzbekistan. In individual men’s foil, Gassner won against Belarus’ Uladzislau Kurylovich, 15-10. Bronze medals went to Akhmadillokhon Solikhojiev (UZB) and Mukhammad Yusuf Asranov (UZB). In individual women’s foil, Cammilletti won against the Philippines’ Maxine Isabel Esteban, 15-2. Bronze medals went to Madinabonu Parpieva (UZB) and Umida Ilyosova (UZB). The event was held in accordance with FIE rules and COVID-19 protocol. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 10-title\" style=\"top:99px;left:485px;\" src=\"/120/en/static/_content/10-title-1.png\">\n        <img class=\"abs halfScale 10-sub\" style=\"top:309px;left:516px;\" src=\"/120/en/static/_content/10-sub-1.png\">\n        <img class=\"abs halfScale 10-line\" style=\"top:305px;left:483px;\" src=\"/120/en/static/_content/10-line-1.png\">\n        <img id=\"10-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"korea-s-kim-greece-s-georgiadou-win-2021-orleans-sabre-grand-prix\">Korea\u2019s Kim, Greece\u2019s Georgiadou Win 2021 Orleans Sabre Grand Prix</h2>\n        <img src=\"/120/en/static/_content/10-mobile-1.jpg\">\n        <p><strong>Orleans, France<br>13 November 2021</strong></p>\n        <p><strong>In the first FIE Grand Prix of the 2021-2022 competition season, Korea\u2019s world champion Junghwan Kim and Greece\u2019s Despina Georgiadou won men\u2019s and women\u2019s individual events at the Orleans Sabre Grand Prix. </strong></p>\n        <p>The finals took place at the Z\xE9nith d\u2019Orl\xE9ans sports arena with a total of 170 men and 162 women participating in the overall competition. </p>\n        <p>In the men\u2019s sabre event final, Kim faced Italy\u2019s Luca Curatoli, winning the gold medal, 15-3. Curatoli defeated Japan\u2019s Kento Yoshida in the semifinal round, 15-10, and Kim beat his teammate and world champion Sanguk Oh, 15-13.</p>\n        <p>In the women\u2019s sabre event final, Georgiadou defeated her teammate, Theodora Gkountoura, by a single point, 15-14, to take the gold. Gkountoura beat Korea\u2019s Jisu Yoon in the semifinal round, 15-12, and Georgiadou won against Russia\u2019s Svetlana Sheveleva, 15-12. Notably, in the quarterfinals Yoon beat her teammate and Olympic champion Jiyeon  Kim, 15-13. </p>\n        <p>Final men\u2019s sabre ranking included Junghwan Kim (KOR, gold), Luca Curatoli (ITA, silver), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) and Enver Yildirim (TUR).</p>\n        <p>Final women\u2019s sabre ranking included Despina Georgiadou (GRE, gold), Theodora Gkountoura (GRE, silver), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) and Amalia Aime (FRA).</p>\n        <p>Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the FIE video series on our YouTube channel.</p>\n        <p>Click Here to relive the men\u2019s and women\u2019s matches of the Orleans Sabre Fencing Grand Prix.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim\n            .fromTo(cOf(\"10-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"10-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"10-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"10-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg10Anim.stop();\n          resetNumbers(\"10-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  KOREA’S KIM, GREECE’S GEORGIADOU WIN 2021 ORLEANS SABRE GRAND PRIX ORLEANS, FRANCE 13 NOVEMBER 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"11-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim\n            .fromTo(idOf(\"11-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          resetNumbers(\"11-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SABRE GRAND PRIX ORLEANS, FRANCE, 2 OF 3  In the first FIE Grand Prix of the 2021-2022 competition season, Korea’s world champion Junghwan Kim and Greece’s Despina Georgiadou won men’s and women’s individual events at the Orleans Sabre Grand Prix. The finals took place at the Zénith d’Orléans sports arena with a total of 170 men and 162 women participating in the overall competition. In the men’s sabre event final, Kim faced Italy’s Luca Curatoli, winning the gold medal, 15-3. Curatoli defeated Japan’s Kento Yoshida in the semifinal round, 15-10, and Kim beat his teammate and world champion Sanguk Oh, 15-13. In the women’s sabre event final, Georgiadou defeated her teammate, Theodora Gkountoura, by a single point, 15-14, to take the gold. Gkountoura beat Korea’s Jisu Yoon in the semifinal round, 15-12, and Georgiadou won against Russia’s Svetlana Sheveleva, 15-12. Notably, in the quarterfinals Yoon beat her"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions/2022/158\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 460px; right: 152px; width: 122px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 412px; right: 208px; width: 130px; height: 21px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo/videos\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 342px; right: 430px; width: 99px; height: 21px;\"></div>\n        </a>\n\n        <img id=\"12-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim\n            .fromTo(idOf(\"12-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          resetNumbers(\"12-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SABRE GRAND PRIX ORLEANS, FRANCE, 3 OF 3  teammate and Olympic champion Jiyeon Kim, 15-13. Final men’s sabre ranking included Junghwan Kim (KOR, gold), Luca Curatoli (ITA, silver), Sanguk Oh (KOR, bronze), Kento Yoshida (JPN, bronze), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) and Enver Yildirim (TUR).  Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the FIE video series on our YouTube channel. Click Here to relive the men’s and women’s matches of the Orleans Sabre Fencing Grand Prix. ■  Final women’s sabre ranking included Despina Georgiadou (GRE, gold), Theodora Gkountoura (GRE, silver), Svetlana Sheveleva (RUS, bronze), Jisu Yoon (KOR, bronze), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) and Amalia Aime (FRA).  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:lammet@mail.ru\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 317px; right: 113px; width: 197px; height: 24px;\"></div> </a>\n        <a href=\"https://www.lammet.ru\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 292px; right: 177px; width: 132px; height: 24px;\"></div> </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.lammet.ru\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/13-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "From Russia with great victories and traditions. \"LM Group\"  129226 Russia, Moscow, Sel'skokhozyaystvennaya street, 26 / 5  email: lammet@mail.ru www.lammet.ru +7(926)227-06-58"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 14-title\" style=\"top:70px;left:64px;\" src=\"/120/en/static/_content/14-title-1.png\">\n        <img class=\"abs halfScale 14-sub\" style=\"top:220px;left:97px;\" src=\"/120/en/static/_content/14-sub-1.png\">\n        <img class=\"abs halfScale 14-line\" style=\"top:218px;left:64px;\" src=\"/120/en/static/_content/14-line-1.png\">\n        <img id=\"14-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"france-s-jacques-andre-coquin-and-team-russia-win-glaive-de-tallinn-women-s-epee-world-cup\">\n          France\u2019s Jacques Andre Coquin and Team Russia Win \u201CGlaive de Tallinn\u201D Women\u2019s\n          Epee World Cup</h2>\n        <img src=\"/120/en/static/_content/14-mobile-1.jpg\">\n        <p><strong>Tallinn, Estonia<br>19-21 November 2021</strong></p>\n        <p>France\u2019s Josephine Jacques Andre Coquin won the individual gold medal and\n          Russia won the gold in the team competition at the 51st \u201CGlaive de Tallinn\u201D\n          Women\u2019s Epee World Cup. </p>\n        <p>With 246 women\u2019s epee fencers and 26 teams competing, it was the first senior\n          women\u2019s FIE World Cup of the 2021-2022 competition season. The event took\n          place at the Kalev Sports Hall.</p>\n        <p>In women\u2019s individual epee, Jacques Andre Coquin faced her teammate,\n          Marie-Florence Candassamy in the final match, winning with a 15-11 score.\n          Candassamy beat Italy\u2019s Federica Isola in the semifinal round, 15-9, and\n          Jacques Andre Coquin defeated her teammate, Alexandra Louis Marie, 15-11.</p>\n        <p>In women\u2019s team epee, Russia won against Germany, 43-37. Germany beat Italy\n          in the semifinal round, 32-31, and Russia defeated Korea, 45-35. Italy took\n          the bronze medal against Korea, 45-33.</p>\n        <p>Individual women\u2019s epee final rankings included Josephine Jacques Andre\n          Coquin (FRA, gold), Marie-Florence Candassamy (FRA, silver), Federica Isola\n          (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata Knapik-Miazga\n          (POL), Aliya Luty (FRA), Anna Van Brummen (USA) and Lauren Rembi (FRA).</p>\n        <p>Team women\u2019s epee final rankings included Russia (gold), Germany (silver),\n          Italy (bronze), Korea, Estonia, Switzerland, France and Poland.</p>\n        <p>Complete and official results for the event may be found here on the FIE web\n          site. For more exciting world fencing news and features, check out the FIE\n          video series on the YouTube FIE Fencing Channel.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim\n            .fromTo(cOf(\"14-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"14-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"14-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"14-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg14Anim.stop();\n          resetNumbers(\"14-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  FRANCE’S JACQUES ANDRE COQUIN AND TEAM RUSSIA WIN “GLAIVE DE TALLINN” WOMEN’S EPEE WORLD CUP TALLINN, ESTONIA 19-21 NOVEMBER 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"15-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim\n            .fromTo(idOf(\"15-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          resetNumbers(\"15-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 2 OF 3  France’s Josephine Jacques Andre Coquin won the individual gold medal and Russia won the gold in the team competition at the 51st “Glaive de Tallinn” Women’s Epee World Cup. With 246 women’s epee fencers and 26 teams competing, it was the first senior women’s FIE World Cup of the 2021-2022 competition season. The event took place at the Kalev Sports Hall.  In women’s individual epee, Jacques Andre Coquin faced her teammate, MarieFlorence Candassamy in the final match, winning with a 15-11 score. Candassamy beat Italy’s Federica Isola in the semifinal round, 15-9, and Jacques Andre Coquin defeated her teammate, Alexandra Louis Marie, 15-11. In women’s team epee, Russia won against Germany, 43-37. Germany beat Italy in the semifinal round, 32-31, and Russia defeated"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 319px; right: 233px; width: 114px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 272px; right: 277px; width: 136px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"16-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim\n            .fromTo(idOf(\"16-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "WOMEN'S EPEE WORLD CUP TALLINN, ESTONIA 3 OF 3  Korea, 45-35. Italy took the bronze medal against Korea, 45-33. Individual women’s epee final rankings included Josephine Jacques Andre Coquin (FRA, gold), Marie-Florence Candassamy (FRA, silver), Federica Isola (ITA, bronze), Alexandra Louis Marie (FRA, bronze), Renata KnapikMiazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) and Lauren Rembi (FRA). Team women’s epee final rankings included Russia (gold), Germany (silver), Italy (bronze), Korea, Estonia, Switzerland, France and Poland. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the FIE video series on the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 17-title\" style=\"top:92px;left:64px;\" src=\"/120/en/static/_content/17-title-1.png\">\n        <img class=\"abs halfScale 17-sub\" style=\"top:206px;left:97px;\" src=\"/120/en/static/_content/17-sub-1.png\">\n        <img class=\"abs halfScale 17-line\" style=\"top:204px;left:64px;\" src=\"/120/en/static/_content/17-line-1.png\">\n        <img id=\"17-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"venezuela-s-limardo-gascon-team-russia-win-bern-men-s-epee-world-cup\">\n          Venezuela\u2019s Limardo Gascon, Team Russia Win Bern Men&#39;s Epee World Cup</h2>\n        <img src=\"/120/en/static/_content/17-mobile-1.jpg\">\n        <p>\u200B\u200B<strong>Bern, Switzerland<br>19-\u200B\u200B21 November 2021</strong></p>\n        <p><strong>Venezuela\u2019s Olympic champion Ruben Limardo Gascon won the individual\n            gold medal and Russia won the gold in the team competition at the Bern\n            Men&#39;s Epee World Cup. </strong></p>\n        <p>With 265 epee fencers and 33 teams competing, it was the first senior men\u2019s\n          FIE World Cup of the 2021-2022 competition season. The event took place at\n          Bern\u2019s Sporthalle Wankdorf.</p>\n        <p>In men\u2019s individual epee, Limardo Gascon faced France\u2019s Alexandre Bardenet in\n          the final match, winning with a 15-7 score. Bardenet defeated his teammate and\n          Olympic gold medallist Romain Cannone in the semifinal round, 15-9, and\n          Limardo Gascon beat Italy\u2019s Andrea Santarelli by a single touch, 10-9.\n          Bardenet also won against teammate and world champion Yannick Borel in the\n          quarterfinals, 15-9.</p>\n        <p>In men\u2019s team epee, Russia won by a single point against Spain, 45-44. Spain\n          beat Hungary in the semifinal round, 45-42, and Russia defeated Japan, 45-34.\n          Japan took the bronze medal against Hungary, 45-34.</p>\n        <p>Individual men\u2019s epee final rankings included Ruben Limardo Gascon (VEN,\n          gold), Alexandre Bardenet (FRA, silver), Romain Cannone (FRA, bronze), Andrea\n          Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA)\n          and Georgiy Bruev (RUS).</p>\n        <p>Team men\u2019s epee final rankings included Russia (gold), Spain (silver), Japan\n          (bronze), Hungary, France, Ukraine, Denmark and Italy.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim\n            .fromTo(cOf(\"17-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"17-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"17-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"17-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  VENEZUELA’S LIMARDO GASCON, TEAM RUSSIA WIN BERN MEN'S EPEE WORLD CUP BERN, SWITZERLAND 19-21 NOVEMBER 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"18-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim\n            .fromTo(idOf(\"18-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          resetNumbers(\"18-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "MEN'S EPEE WORLD CUP BERN, SWITZERLAND 2 OF 2  Venezuela’s Olympic champion Ruben Limardo Gascon won the individual gold medal and Russia won the gold in the team competition at the Bern Men's Epee World Cup. With 265 epee fencers and 33 teams competing, it was the first senior men’s FIE World Cup of the 2021-2022 competition season. The event took place at Bern’s Sporthalle Wankdorf. In men’s individual epee, Limardo Gascon faced France’s Alexandre Bardenet in the final match,  winning with a 15-7 score. Bardenet defeated his teammate and Olympic gold medallist Romain Cannone in the semifinal round, 159, and Limardo Gascon beat Italy’s Andrea Santarelli by a single touch, 10-9. Bardenet also won against teammate and world champion Yannick Borel in the quarterfinals, 15-9. In men’s team epee, Russia won by a single point against Spain, 45-44. Spain beat Hungary in the semifinal round, 45-42, and Russia defeated Japan, 45-34. Japan took the bronze medal against Hungary, 45-34. Individual men’s epee final rankings included Ruben Limardo Gascon (VEN, gold), Alexandre Bardenet (FRA, silver), Romain Cannone (FRA, bronze), Andrea Santarelli (ITA, bronze), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) and Georgiy Bruev (RUS). Team men’s epee final rankings included Russia (gold), Spain (silver), Japan (bronze), Hungary, France, Ukraine, Denmark and Italy. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/en/static/_content/19-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "© Augusto Bizzi  TOGETHER WE STAND."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 20-title\" style=\"top:64px;left:487px;\" src=\"/120/en/static/_content/20-title-1.png\">\n        <img class=\"abs halfScale 20-sub\" style=\"top:217px;left:519px;\" src=\"/120/en/static/_content/20-sub-1.png\">\n        <img class=\"abs halfScale 20-line\" style=\"top:220px;left:487px;\" src=\"/120/en/static/_content/20-line-1.png\">\n        <img id=\"20-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"italy-s-alice-volpi-and-team-italy-win-gold-at-st-maur-women-s-foil-world-cup\">\n          Italy\u2019s Alice Volpi and Team Italy Win Gold at St. Maur Women\u2019s Foil World Cup\n        </h2>\n        <img src=\"/120/en/static/_content/20-mobile-1.jpg\">\n        <p><strong>Saint-Maur-des-Foss\xE9s, France<br>10-12 De\u200B\u200Bcember 2021</strong></p>\n        <p><strong>Italy\u2019s world champion Alice Volpi won the individual gold medal and\n            Italy took the gold in the team competition at the St. Maur Women\u2019s Foil\n            World Cup.</strong></p>\n        <p>The event took place at the Sport Centre Pierre Brossolette, with 182 women\u2019s\n          foil fencers and 20 teams competing.</p>\n        <p>Volpi faced U.S. Olympic champion Lee Kiefer in the gold-medal match of\n          individual women\u2019s foil, winning by a single touch, 15-14. Kiefer beat her\n          teammate, Jacqueline Dubrovich, in the semifinal round, 15-4, and Volpi also\n          defeated her teammate, Francesca Palumbo, 15-12.</p>\n        <p>In women\u2019s team foil, Italy scored gold over Japan in the final round,\n          winning with a 43-40 score. Japan beat Russia in the semifinals, 31-26, and\n          Italy won against Canada, 45-37. The bronze medal went to Russia over Canada,\n          44-39.</p>\n        <p>Individual women\u2019s foil rankings included Alice Volpi (ITA, gold), Lee Kiefer\n          (USA, silver), Jacqueline Dubrovich (USA, bronze), Francesca Palumbo (ITA,\n          bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS)\n          and Kiyeun Kim (KOR).</p>\n        <p>Women\u2019s team foil rankings included Italy (gold), Japan (silver), Russia\n          (bronze), Canada, Poland, China, USA and Hong Kong, China.</p>\n        <p>Complete and official results for the event may be found here on the FIE web\n          site. For more exciting world fencing news and features, check out the YouTube\n          FIE Fencing Channel.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim\n            .fromTo(cOf(\"20-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"20-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"20-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"20-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  ITALY’S ALICE VOLPI AND TEAM ITALY WIN GOLD AT ST. MAUR WOMEN’S FOIL WORLD CUP SAINT-MAUR-DES-FOSSÉS, FRANCE 10-12 DECEMBER 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 248px; right: 233px; width: 114px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 201px; right: 170px; width: 173px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"21-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim\n            .fromTo(idOf(\"21-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "WOMEN'S FOIL WORLD CUP SAINT-MAUR-DESFOSSÉS, FRANCE 2 OF 2  Italy’s world champion Alice Volpi won the individual gold medal and Italy took the gold in the team competition at the St. Maur Women’s Foil World Cup. The event took place at the Sport Centre Pierre Brossolette, with 182 women’s foil fencers and 20 teams competing. Volpi faced U.S. Olympic champion Lee Kiefer in the gold-medal match of individual women’s foil, winning by a single touch, 15-14. Kiefer beat her teammate, Jacqueline Dubrovich, in the semifinal round, 15-4, and Volpi also defeated her teammate, Francesca Palumbo, 15-12. In women’s team foil, Italy scored gold over Japan in the final round, winning with a 4340 score. Japan beat Russia in the semifinals, 31-26, and Italy won against Canada, 45-37. The bronze medal went to Russia over Canada, 44-39.  Palumbo (ITA, bronze), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) and Kiyeun Kim (KOR). Women’s team foil rankings included Italy (gold), Japan (silver), Russia (bronze), Canada, Poland, China, USA and Hong Kong, China. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  Individual women’s foil rankings included Alice Volpi (ITA, gold), Lee Kiefer (USA, silver), Jacqueline Dubrovich (USA, bronze), Francesca  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 22-title\" style=\"top:85px;left:363px;\" src=\"/120/en/static/_content/22-title-1.png\">\n        <img class=\"abs halfScale 22-sub\" style=\"top:285px;left:396px;\" src=\"/120/en/static/_content/22-sub-1.png\">\n        <img class=\"abs halfScale 22-line\" style=\"top:282px;left:363px;\" src=\"/120/en/static/_content/22-line-1.png\">\n        <img id=\"22-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"hong-kong-s-cheung-team-italy-take-gold-in-challenge-international-de-paris-men-s-foil-world-cup\">\n          Hong Kong\u2019s Cheung, Team Italy take Gold in Challenge International de Paris\n          Men\u2019s Foil World Cup</h2>\n        <img src=\"/120/en/static/_content/22-mobile-1.jpg\">\n        <p><strong>Paris, France<br>14-16 January 2022</strong></p>\n        <p><strong>Hong Kong\u2019s Olympic champion Ka Long Cheung won the individual gold\n            medal and Italy took the gold in the team competition at the Challenge\n            International (CIP) de Paris Men\u2019s Foil World Cup.</strong></p>\n        <p>The event, which took place at the Stade Pierre de Coubertin, included 210\n          fencers and 26 teams participating.</p>\n        <p>Cheung fenced Italy\u2019s Edoardo Luperi in the final round of individual men\u2019s\n          foil, winning the gold with a score of 15-12. Luperi defeated USA\u2019s Chase\n          Emmer in the semifinal round, 15-13, while Cheung beat Italy\u2019s world champion\n          Alessio Foconi, 15-4. Cheung also won against French world champion Enzo\n          Lefort in the quarterfinals, 15-9, and in the same round Emmer beat Italian\n          Olympic champion Daniele Garozzo, 15-5.</p>\n        <p>Italy took the gold in men\u2019s team foil, defeating France in the final match,\n          45-20. France beat Russia in the semifinal round, 45-39, while Italy won\n          against USA, 45-38. USA took the bronze medal against Russia, 45-31.</p>\n        <p>Final ranking in individual men\u2019s foil included Ka Long Cheung (HKG, gold),\n          Edoardo Luperi (ITA, silver), Chase Emmer (USA, bronze), Alessio Foconi (ITA,\n          bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA)\n          and Alexandre Sido (FRA).</p>\n        <p>Final ranking in team men\u2019s foil included Italy (gold), France (silver), USA\n          (bronze), Russia, Japan, Egypt, Korea and Hong Kong China.</p>\n        <p>Complete and official results for the event may be found here on the FIE web\n          site. For more exciting world fencing news and features, check out the YouTube\n          FIE Fencing Channel.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim\n            .fromTo(cOf(\"22-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"22-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"22-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"22-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg22Anim.stop();\n          resetNumbers(\"22-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  HONG KONG’S CHEUNG, TEAM ITALY TAKE GOLD IN CHALLENGE INTERNATIONAL DE PARIS MEN’S FOIL WORLD CUP PARIS, FRANCE 14-16 JANUARY 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 201px; right: 233px; width: 114px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 154px; right: 170px; width: 245px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"23-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim\n            .fromTo(idOf(\"23-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          resetNumbers(\"23-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "MEN'S FOIL WORLD CUP PARIS, FRANCE 2 OF 2  Hong Kong’s Olympic champion Ka Long Cheung won the individual gold medal and Italy took the gold in the team competition at the Challenge International (CIP) de Paris Men’s Foil World Cup. The event, which took place at the Stade Pierre de Coubertin, included 210 fencers and 26 teams participating. Cheung fenced Italy’s Edoardo Luperi in the final round of individual men’s foil, winning the gold with a score of 15-12. Luperi defeated USA’s Chase Emmer in the semifinal round, 1513, while Cheung beat Italy’s world champion Alessio Foconi, 15-4. Cheung also won against French world champion Enzo Lefort in the quarterfinals, 15-9, and in the same round Emmer beat Italian Olympic champion Daniele Garozzo, 15-5. Italy took the gold in men’s team foil, defeating France in the final match, 45-20. France beat Russia in the semifinal round, 45-39, while Italy won against USA, 45-38. USA took the bronze medal against Russia, 45-31.  Final ranking in individual men’s foil included Ka Long Cheung (HKG, gold), Edoardo Luperi (ITA, silver), Chase Emmer (USA, bronze), Alessio Foconi (ITA, bronze), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) and Alexandre Sido (FRA). Final ranking in team men’s foil included Italy (gold), France (silver), USA (bronze), Russia, Japan, Egypt, Korea and Hong Kong China. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"  bottom: 173px; right: 981px; width: 177px; height: 25px; }\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/pg24.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Foils, epees, sabers  BF… the Best for Fencing SAS BLAISE FRERES ZI du Bec - Rue Antoine Lavoisier 42700 - LE CHAMBON-FEUGEROLLES – FRANCE https://www.blaise-freres.fr"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 25-title\" style=\"top:87px;left:484px;\" src=\"/120/en/static/_content/25-title-1.png\">\n        <img class=\"abs halfScale 25-sub\" style=\"top:243px;left:770px;\" src=\"/120/en/static/_content/25-sub-1.png\">\n        <img class=\"abs halfScale 25-line\" style=\"top:241px;left:738px;\" src=\"/120/en/static/_content/25-line-1.png\">\n        <img id=\"25-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"italy-s-volpi-team-usa-win-gold-at-poznan-women-s-foil-world-cup\">\n          Italy\u2019s Volpi, Team USA win gold at Poznan Women\u2019s Foil World Cup</h2>\n        <p><strong>Poznan, Poland<br>14-16 January 2022</strong></p>\n        <img src=\"/120/en/static/_content/25-mobile-1.jpg\">\n        <p><strong>Italy\u2019s world champion Alice Volpi took the individual gold medal and\n            Team USA won the team gold at the Adam Mickiewicz University Women\u2019s Foil\n            World Cup in Poznan, Poland.</strong></p>\n        <p>The event took place at the UAM Sport Center, with 180 fencers and 20 teams\n          competing.</p>\n        <p>In the final round of individual women\u2019s foil, Volpi faced Canada\u2019s Eleanor\n          Harvey, winning the gold with a 15-10 score. In the semifinal round, Harvey\n          beat China\u2019s Qingyuan Chen, 15-7, and Volpi defeated teammate Martina\n          Favaretto, 15-11.</p>\n        <p>In women\u2019s team foil, USA defeated Japan in the final match, winning the gold\n          with a 45-23 score. Japan won against Poland in the semifinals, 27-25, and USA\n          beat Russia, 45-39. Poland took the bronze medal over Russia, 44-42.</p>\n        <p>Individual women\u2019s foil rankings included Alice Volpi (ITA, gold), Eleanor\n          Harvey (CAN, silver), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN,\n          bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova\n          (RUS) and Elena Petrova (RUS).</p>\n        <p>Women\u2019s team foil rankings included USA (gold), Japan (silver), Poland\n          (bronze), Russia, Italy, China, France and Canada.</p>\n        <p>Complete and official results for the event may be found here on the FIE web\n          site. For more exciting world fencing news and features, check out the YouTube\n          FIE Fencing Channel.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim\n            .fromTo(cOf(\"25-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"25-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"25-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"25-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg25Anim.stop();\n          resetNumbers(\"25-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  ITALY’S VOLPI, TEAM USA WIN GOLD AT POZNAN WOMEN’S FOIL WORLD CUP POZNAN, POLAND 14-16 JANUARY 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 201px; right: 233px; width: 114px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 154px; right: 170px; width: 245px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"26-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim\n            .fromTo(idOf(\"26-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          resetNumbers(\"26-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "WOMEN'S FOIL WORLD CUP POZNAN, POLAND 2 OF 2  Italy’s world champion Alice Volpi took the individual gold medal and Team USA won the team gold at the Adam Mickiewicz University Women’s Foil World Cup in Poznan, Poland. The event took place at the UAM Sport Center, with 180 fencers and 20 teams competing. In the final round of individual women’s foil, Volpi faced Canada’s Eleanor Harvey, winning the gold with a 15-10 score. In the semifinal round, Harvey beat China’s Qingyuan Chen,  15-7, and Volpi defeated teammate Martina Favaretto, 15-11. In women’s team foil, USA defeated Japan in the final match, winning the gold with a 45-23 score. Japan won against Poland in the semifinals, 27-27, and USA beat Russia, 45-39. Poland took the bronze medal over Russia, 44-42. Individual women’s foil rankings included Alice Volpi (ITA, gold), Eleanor Harvey (CAN, silver), Martina Favaretto (ITA, bronze), Qingyuan Chen (CHN, bronze), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) and Elena Petrova (RUS). Women’s team foil rankings included USA (gold), Japan (silver), Poland (bronze), Russia, Italy, China, France and Canada. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 27-title\" style=\"top:64px;left:454px;\" src=\"/120/en/static/_content/27-title-1.png\">\n        <img class=\"abs halfScale 27-sub\" style=\"top:265px;left:487px;\" src=\"/120/en/static/_content/27-sub-1.png\">\n        <img class=\"abs halfScale 27-line\" style=\"top:262px;left:454px;\" src=\"/120/en/static/_content/27-line-1.png\">\n        <img id=\"27-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <p><strong>Tbilisi, Georgia<br>14-18 January 2022</strong></p>\n        <h2\n          id=\"georgia-s-bazadze-france-s-queroli-teams-korea-and-france-win-gold-at-tbilisi-sabre-world-cup\">\n          Georgia\u2019s Bazadze, France\u2019s Queroli, Teams Korea and France Win Gold at\n          Tbilisi Sabre World Cup</h2>\n        <img src=\"/120/en/static/_content/27-mobile-1.jpg\">\n        <p><strong>Georgia\u2019s Sandro Bazadze and France\u2019s Caroline Queroli took\n            individual gold medals, with Korea and France winning men\u2019s and women\u2019s team\n            competitions at the Tbilisi Sabre World Cup. </strong></p>\n        <p>The event, which took place at the Olympic Palace, included 188 men and 154\n          women competing as well as 24 men\u2019s and 25 women\u2019s teams. </p>\n        <p>Bazadze faced Russia\u2019s Kamil Ibragimov in the final match of individual men\u2019s\n          sabre, winning with a 15-8 score. Ibragimov beat Korean world champion\n          Junghwan Kim in the semifinal round, 15-12, while Bazadze won against France\u2019s\n          Bolade Apithy, 15-10. Apithy defeated Korean world champion Sanguk Oh in the\n          quarterfinals, 15-8, and Kim beat Hungarian world champion Andras Szatmari in\n          the same round, 15-12.</p>\n        <p>Queroli won against Greece\u2019s Theodora Gkountoura in the final match of\n          individual women\u2019s sabre, 15-12. Gkountoura beat Russia\u2019s Olympic champion\n          Yana Egorian in the semifinals, 15-14, while Queroli defeated Italy\u2019s Rossella\n          Gregorio, 15-14.</p>\n        <p>In men\u2019s team sabre, Korea won against Germany in the final match, 45-38.\n          Germany defeated Italy in the semifinal round, 45-43, while Korea beat Russia,\n          45-44. The bronze medal went to Russia after winning against Italy, 45-40.</p>\n        <p>In women\u2019s team sabre, France took the gold medal, winning against Korea in\n          the final, 45-35. France beat Spain in the semifinal round, 45-34, while Korea\n          defeated Russia, 45-39. The bronze medal went to Russia over Spain, 45-43.</p>\n        <p>Final rankings in men\u2019s individual sabre included Sandro Bazadze (GEO, gold),\n          Kamil Ibragimov (RUS, silver), Bolade Apithy (FRA, bronze), Junghwan Kim (KOR,\n          bronze), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) and\n          Giovanni Repetti (ITA).</p>\n        <p>Final rankings in women\u2019s individual sabre included Caroline Queroli (FRA,\n          gold), Theodora Gkountoura (GRE, silver), Yana Egorian (RUS, bronze), Rossella\n          Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS),\n          Sara Balzer (FRA) and Seri Ozaki (JPN).</p>\n        <p>Final rankings in men\u2019s team sabre included Korea (gold), Germany (silver)\n          Russia (bronze), Italy, Iran, Egypt, Hungary and France. </p>\n        <p>Final rankings in women\u2019s team sabre included France (gold), Korea (silver),\n          Russia (bronze), Spain, Italy, Bulgaria, Hungary and Poland. </p>\n        <p>Complete and official results for the event may be found here on the FIE web\n          site. For more exciting world fencing news and features, check out the YouTube\n          FIE Fencing Channel.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim\n            .fromTo(cOf(\"27-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"27-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"27-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"27-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg27Anim.stop();\n          resetNumbers(\"27-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  GEORGIA’S BAZADZE, FRANCE’S QUEROLI, TEAMS KOREA AND FRANCE WIN GOLD AT TBILISI SABRE WORLD CUP TBILISI, GEORGIA 14-18 JANUARY 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"28-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim\n            .fromTo(idOf(\"28-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          resetNumbers(\"28-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SABRE WORLD CUP TBILISI, GEORGIA 2 OF 3  Georgia’s Sandro Bazadze and France’s Caroline Queroli took individual gold medals, with Korea and France winning men’s and women’s team competitions at the Tbilisi Sabre World Cup. The event, which took place at the Olympic Palace, included 188 men and 154 women competing as well as 24 men’s and 27 women’s teams. Bazadze faced Russia’s Kamil Ibragimov in the final match of individual men’s sabre, winning with a 15-8 score. Ibragimov beat Korean world champion Junghwan Kim in the semifinal round, 15-12, while Bazadze won against France’s Bolade Apithy, 15-10. Apithy defeated Korean world champion Sanguk Oh in the quarterfinals, 15-8, and Kim beat Hungarian world champion Andras Szatmari in the same round, 15-12. Queroli won against Greece’s Theodora Gkountoura in the final match of individual women’s sabre, 15-12. Gkountoura beat Russia’s Olympic champion Yana Egorian in  the semifinals, 15-14, while Queroli defeated Italy’s Rossella Gregorio, 15-14. In men’s team sabre, Korea won against Germany in the final match, 45-38. Germany defeated Italy in the semifinal round, 45-43, while Korea beat Russia, 45-44. The bronze medal went to Russia after winning against Italy, 45-40."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 296px; right: 233px; width: 114px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 247px; right: 168px; width: 174px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"29-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim\n            .fromTo(idOf(\"29-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SABRE WORLD CUP TBILISI, GEORGIA 3 OF 3  In women’s team sabre, France took the gold medal, winning against Korea in the final, 45-35. France beat Spain in the semifinal round, 45-34, while Korea defeated Russia, 45-39. The bronze medal went to Russia over Spain, 45-43. Final rankings in men’s individual sabre included Sandro Bazadze (GEO, gold), Kamil Ibragimov (RUS, silver), Bolade Apithy (FRA, bronze), Junghwan Kim (KOR, bronze), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) and Giovanni Repetti (ITA). Final rankings in women’s individual sabre included Caroline Queroli (FRA, gold), Theodora Gkountoura (GRE, silver), Yana Egorian (RUS, bronze), Rossella Gregorio (ITA, bronze), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) and Seri Ozaki (JPN).  Final rankings in men’s team sabre included Korea (gold), Germany (silver) Russia (bronze), Italy, Iran, Egypt, Hungary and France. Final rankings in women’s team sabre included France (gold), Korea (silver), Russia (bronze), Spain, Italy, Bulgaria, Hungary and Poland. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.facebook.com/uhlmann.fencing/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 1095px; width: 19px; height: 18px;\"></div>\n        </a>\n        <a href=\"https://www.instagram.com/uhlmann.fencing/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 1074px; width: 19px; height: 18px;\"></div>\n        </a>\n        <a href=\"https://uhlmann-fechtsport.com/en/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 966px; width: 104px; height: 18px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://uhlmann-fechtsport.com/en/\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/30-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "uhlmann-fencing.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 31-title\" style=\"top:81px;left:64px;\" src=\"/120/en/static/_content/31-title-1.png\">\n        <img class=\"abs halfScale 31-sub\" style=\"top:188px;left:97px;\" src=\"/120/en/static/_content/31-sub-1.png\">\n        <img class=\"abs halfScale 31-line\" style=\"top:185px;left:64px;\" src=\"/120/en/static/_content/31-line-1.png\">\n        <img id=\"31-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"azerbaijans-bashta-team-france-win-gold-at-women-s-sabre-world-cup\">\n          Azerbaijans Bashta, Team France win gold at Women\u2019s Sabre World Cup</h2>\n        <img src=\"/120/en/static/_content/31-mobile-1.jpg\">\n        <p><strong>Plovdiv, Bulgaria<br>28-30 January 2022</strong></p>\n        <p><strong>Azerbaijan\u2019s Anna Bashta and Team France took gold medals at the\n            Women\u2019s Sabre World Cup in Plovdiv, Bulgaria.</strong></p>\n        <p>The event, which took place at the Complex SILA, included 136 women\u2019s sabre\n          fencers and 20 teams.</p>\n        <p>Bashta faced France\u2019s Manon Apithy-Brunet in the final round of the\n          individual event, winning with at 15-10 score. Apithy-Brunet beat her\n          teammate, Malina Vongsavady, in the semifinals, 15-9, and Bashta defeated\n          Italy\u2019s Rossella Gregorio, 15-13.</p>\n        <p>In the women\u2019s team sabre competition, France defeated Azerbaijan in the\n          final match, 45-39. Azerbaijan won against Bulgaria in the semifinals, 45-32,\n          and France beat Italy, 45-23. Italy went on to take the bronze medal against\n          Bulgaria, 45-29.</p>\n        <p>Individual women\u2019s sabre rankings included Anna Bashta (AZE, gold), Manon\n          Apithy-Brunet (FRA, silver), Rossella Gregorio (ITA, bronze), Malina\n          Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga\n          Nikitina (RUS) and Svetlana Sheveleva (RUS).</p>\n        <p>Rankings for women\u2019s team sabre included France (gold), Azerbaijan (silver),\n          Italy (bronze), Bulgaria, Hungary, Spain, Turkey and Germany.</p>\n        <p>Complete and official results for the event may be found here on the FIE web\n          site. For more exciting world fencing news and features, check out the YouTube\n          FIE Fencing Channel.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim\n            .fromTo(cOf(\"31-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"31-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"31-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"31-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg31Anim.stop();\n          resetNumbers(\"31-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  AZERBAIJANS BASHTA, TEAM FRANCE WIN GOLD AT WOMEN’S SABRE WORLD CUP PLOVDIV, BULGARIA 28-30 JANUARY 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 201px; right: 233px; width: 114px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 154px; right: 170px; width: 245px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"32-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim\n            .fromTo(idOf(\"32-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          resetNumbers(\"32-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "WOMEN'S SABRE WORLD CUP PLOVDIV, BULGARIA 2 OF 2  Azerbaijan’s Anna Bashta and Team France took gold medals at the Women’s Sabre World Cup in Plovdiv, Bulgaria. The event, which took place at the Complex SILA, included 136 women’s sabre fencers and 20 teams. Bashta faced France’s Manon Apithy-Brunet in the final round of the individual event, winning with at 15-10 score. Apithy-Brunet beat her teammate, Malina Vongsavady, in the semifinals, 15-9, and Bashta defeated Italy’s Rossella Gregorio, 15-13. In the women’s team sabre competition, France defeated Azerbaijan in the final match, 45-39. Azerbaijan won against Bulgaria in the semifinals, 45-32, and France beat Italy, 45-23.  Italy went on to take the bronze medal against Bulgaria, 45-29. Individual women’s sabre rankings included Anna Bashta (AZE, gold), Manon ApithyBrunet (FRA, silver), Rossella Gregorio (ITA, bronze), Malina Vongsavady (FRA, bronze), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) and Svetlana Sheveleva (RUS). Rankings for women’s team sabre included France (gold), Azerbaijan (silver), Italy (bronze), Bulgaria, Hungary, Spain, Turkey and Germany. Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 33-title\" style=\"top:108px;left:395px;\" src=\"/120/en/static/_content/33-title-1.png\">\n        <img class=\"abs halfScale 33-sub\" style=\"top:264px;left:426px;\" src=\"/120/en/static/_content/33-sub-1.png\">\n        <img class=\"abs halfScale 33-line\" style=\"top:263px;left:394px;\" src=\"/120/en/static/_content/33-line-1.png\">\n        <img id=\"33-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"france-s-borel-estonia-s-lehis-win-qatar-epee-grand-prix\">France\u2019s\n          Borel, Estonia\u2019s Lehis win Qatar Epee Grand Prix</h2>\n        <img src=\"/120/en/static/_content/33-mobile-1.jpg\">\n        <p><strong>Doha, Qatar<br>28-30 January 2022</strong></p>\n        <p><strong>France\u2019s world champion Yannick Borel and Estonia\u2019s Katrina Lehis\n            took individual gold medals at the 2022 Qatar Fencing Epee Grand Prix in\n            Doha.</strong></p>\n        <p>The event, which took place at the Aspire Zone/Aspire Dome sports complex,\n          included 161 men and 120 women competing.</p>\n        <p>In the final match of individual men\u2019s epee, Borel faced teammate Aymerick\n          Gally, winning with a 15-10 score. Gally beat Italy\u2019s Federico Vismara in the\n          semifinals, 15-6, and Borel defeated Italy\u2019s Davide Di Veroli, 15-9. Of note,\n          French Olympic champion Romain Cannone lost in the quarterfinals to Borel,\n          15-5, and Hungarian world champion Gergely Siklosi lost against Di Veroli in\n          the round of 16, 15-12.</p>\n        <p>In women\u2019s individual epee, Lehis won in the final round against teammate\n          Nelli Differt, 15-11. Differt beat another teammate, Erika Kirpu, in the\n          semifinal round, 12-11, and Lehis won against France\u2019s Marie-Florence\n          Candassamy, 15-14. Of note, Candassamy beat Ukrainian Olympic champion Yana\n          Shemyakina in the quarterfinals, 15-9.</p>\n        <p>Final ranking in men\u2019s epee included Yannick Borel (FRA, gold), Aymerick\n          Gally (FRA, silver), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA,\n          bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA)\n          and Volodymyr Stankevych (UKR). </p>\n        <p>Final ranking in women\u2019s epee included Katrina Lehis (EST, gold), Nelli\n          Differt (EST, silver), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu\n          (EST, bronze), Renata Knapik- Miazga (POL), Irina Embrich (EST), Anna Kun\n          (HUN) and Yana Shemyakina (UKR).</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim\n            .fromTo(cOf(\"33-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"33-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"33-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"33-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg33Anim.stop();\n          resetNumbers(\"33-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  FRANCE’S BOREL, ESTONIA’S LEHIS WIN QATAR EPEE GRAND PRIX DOHA, QATAR 28-30 JANUARY 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"34-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim\n            .fromTo(idOf(\"34-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"34-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "EPEE GRAND PRIX DOHA, QATAR 2 OF 2  France’s world champion Yannick Borel and Estonia’s Katrina Lehis took individual gold medals at the 2022 Qatar Fencing Epee Grand Prix in Doha. The event, which took place at the Aspire Zone/Aspire Dome sports complex, included 161 men and 120 women competing. In the final match of individual men’s epee, Borel faced teammate Aymerick Gally, winning with a 15-10 score. Gally beat Italy’s Federico Vismara in the semifinals, 15-6, and Borel defeated Italy’s Davide Di Veroli, 15-9. Of note, French Olympic champion Romain Cannone lost in the quarterfinals to Borel, 15-5, and Hungarian world champion Gergely Siklosi lost against Di Veroli in the round of 16, 15-12. In women’s individual epee, Lehis won in the final round against teammate Nelli Differt, 1511. Differt beat another teammate, Erika Kirpu, in the semifinal round, 12-11, and Lehis won against France’s Marie-Florence Candassamy,  15-14. Of note, Candassamy beat Ukrainian Olympic champion Yana Shemyakina in the quarterfinals, 15-9. Final ranking in men’s epee included Yannick Borel (FRA, gold), Aymerick Gally (FRA, silver), Davide Di Veroli (ITA, bronze), Federico Vismara (ITA, bronze), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) and Volodymyr Stankevych (UKR). Final ranking in women’s epee included Katrina Lehis (EST, gold), Nelli Differt (EST, silver), Marie-Florence Candassamy (FRA, bronze), Erika Kirpu (EST, bronze), Renata KnapikMiazga (POL), Irina Embrich (EST), Anna Kun (HUN) and Yana Shemyakina (UKR). ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 35-title\" style=\"top:103px;left:381px;\" src=\"/120/en/static/_content/35-title-1.png\">\n        <img class=\"abs halfScale 35-sub\" style=\"top:207px;left:410px;\" src=\"/120/en/static/_content/35-sub-1.png\">\n        <img class=\"abs halfScale 35-line\" style=\"top:205px;left:378px;\" src=\"/120/en/static/_content/35-line-1.png\">\n        <img id=\"35-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"men-s-and-women-s-epee-grand-prix-in-budapest\">Men\u2019s and Women\u2019s Epee\n          Grand Prix in Budapest</h2>\n        <img src=\"/120/en/static/_content/35-mobile-1.jpg\">\n        <p><strong>Budapest, Hungary<br>4-6 March 2022</strong></p>\n        <p><strong>Venezuela\u2019s Olympic champion Ruben Limardo-Gascon won the individual\n            men\u2019s gold and Italy\u2019s Alberta Santuccio won the individual women\u2019s gold at\n            the Budapest Westend Epee Grand Prix.</strong></p>\n        <p>The competition took place at the BOK Hall (former SYMA Hall) and included\n          271 men\u2019s and 210 women\u2019s epeeists participating. The Grand Prix was dedicated\n          to the memories of J\xF3zsef S\xE1kovics for the men\u2019s event and Gy\u0151z\u0151 Kulcs\xE1r for\n          the women\u2019s event.</p>\n        <p>Limardo Gascon won the gold medal in men\u2019s epee against Hungary\u2019s David Nagy,\n          13-5. Nagy beat Finland\u2019s Niko Vuorinen in the semifinal match, 12-11, while\n          Limardo Gascon won against Italy\u2019s Gabriele Cimini, 13-9. </p>\n        <p>Santuccio won the gold medal in women\u2019s epee against Hungary\u2019s Anna Kun,\n          15-7. Kun beat Estonia\u2019s Katrina Lehis in the semifinal match, 14-11, while\n          Santuccio won against Korea\u2019s Injeong Choi, 12-11. Of note, Lehis defeated\n          Italy\u2019s two-time world champion Rossella Fiamingo in the quarterfinals, 12-11.\n        </p>\n        <p>Final rankings in men\u2019s epee included Ruben Limardo Gascon (VEN, gold), David\n          Nagy (HUN, silver), Gabriele Cimini (ITA, bronze), Niko Vuorinen (FIN,\n          bronze), Andrea Santarelli (ITA), Kazuyasu Minobe (JPN), Ruslan Kurbanov (KAZ)\n          and Mate Tamas Koch (HUN).</p>\n        <p>Final rankings in women\u2019s epee included Alberta Santuccio (ITA, gold), Anna\n          Kun (HUN, silver), Injeong Choi (KOR, bronze), Katrina Lehis (EST, bronze),\n          Rossella Fiamingo (ITA), Katharine Holmes (USA), Anne Cebula (USA) and\n          Kristina Kuusk (EST).</p>\n        <p>Complete and official results for the event may be found here on the FIE web\n          site. For more exciting world fencing news and features, check out the YouTube\n          FIE Fencing Channel.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim\n            .fromTo(cOf(\"35-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"35-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"35-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"35-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg35Anim.stop();\n          resetNumbers(\"35-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  MEN'S AND WOMEN'S EPEE GRAND PRIX IN BUDAPEST BUDAPEST, HUNGARY 4–6 MARCH 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"36-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim\n            .fromTo(idOf(\"36-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          resetNumbers(\"36-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "EPEE GRAND PRIX BUDAPEST, HUNGARY 2 OF 3  Venezuela’s Olympic champion Ruben Limardo-Gascon won the individual men’s gold and Italy’s Alberta Santuccio won the individual women’s gold at the Budapest Westend Epee Grand Prix. The competition took place at the BOK Hall (former SYMA Hall) and included 271 men’s and 210 women’s epeeists participating. The Grand Prix was dedicated to the memories of József Sákovics for the men’s event and Győző Kulcsár for the women’s event. Limardo Gascon won the gold medal in men’s epee against Hungary’s David Nagy, 13-5.  Nagy beat Finland’s Niko Vuorinen in the semifinal match, 12-11, while Limardo Gascon won against Italy’s Gabriele Cimini, 13-9. Santuccio won the gold medal in women’s epee against Hungary’s Anna Kun, 15-7. Kun beat Estonia’s Katrina Lehis in the semifinal match, 14-11, while Santuccio won against Korea’s Injeong Choi, 12-11. Of note, Lehis defeated Italy’s two-time world champion Rossella Fiamingo in the quarterfinals, 12-11. Final rankings in men’s epee included Ruben Limardo Gascon (VEN, gold), David Nagy (HUN, silver), Gabriele Cimini (ITA, bronze), Niko"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 624px; right: 156px; width: 114px; height: 20px; \"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 577px; right: 152px; width: 111px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 554px; right: 388px; width: 139px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"37-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim\n            .fromTo(idOf(\"37-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop();\n          resetNumbers(\"37-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "EPEE GRAND PRIX BUDAPEST, HUNGARY 3 OF 3  Vuorinen (FIN, bronze), Andrea Santarelli (ITA), Kazuyasu Minobe (JPN), Ruslan Kurbanov (KAZ) and Mate Tamas Koch (HUN). Final rankings in women’s epee included Alberta Santuccio (ITA, gold), Anna Kun (HUN, silver), Injeong Choi (KOR, bronze), Katrina Lehis (EST, bronze), Rossella Fiamingo (ITA),  Katharine Holmes (USA), Anne Cebula (USA) and Kristina Kuusk (EST). Complete and official results for the event may be found here on the FIE web site. For more exciting world fencing news and features, check out the YouTube FIE Fencing Channel. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/en/static/_content/38-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 39-title\" style=\"top:75px;left:64px;\" src=\"/120/en/static/_content/39-title-1.png\">\n        <img class=\"abs halfScale 39-sub\" style=\"top:188px;left:694px;\" src=\"/120/en/static/_content/39-sub-1.png\">\n        <img class=\"abs halfScale 39-line\" style=\"top:186px;left:661px;\" src=\"/120/en/static/_content/39-line-1.png\">\n        <img id=\"39-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"a-grand-and-successful-2022-junior-and-cadet-fencing-world-championships-in-dubai\">\n          A grand and successful 2022 Junior and Cadet Fencing World Championships in\n          Dubai</h2>\n        <img src=\"/120/en/static/_content/39-mobile-1.jpg\">\n        <p><strong>Dubai, United Arab Emirates<br>2-10 April 2022</strong></p>\n        <p><strong>The 2022 Junior and Cadet Fencing World Championships have been\n            declared a spectacular success by FIE Interim President Emmanuel\n            Katsiadakis.</strong></p>\n        <p>The nine-day event, which included 18 individual and team events for junior\n          and cadet men and women fencers, had the largest number of participants in its\n          history, with 1357 fencers from 103 countries. It took place at Dubai\u2019s\n          impressive Hamdan Sports Complex, a world-class multi-purpose sports facility\n          known for hosting a broad array of international championships and events.</p>\n        <p>The following shows the countries participating in the Junior and Cadet\n          Fencing World Championships, by continental regions:</p>\n        <ul>\n          <li>Africa 13</li>\n          <li>Americas 20</li>\n          <li>Asia/Oceania 32</li>\n          <li>Europe 38</li>\n          <li>Total 103</li>\n        </ul>\n        <p>The official opening ceremony for the Championships featured several local\n          dignitaries attending, including H.E. Dr. Ahmad bin Abdullah Humaid Belhoul Al\n          Falasi, Minister of State for Entrepreneurship and SMEs and Chairman of the\n          Board of Directors of the General Sports Authority; H.E. Sheikh Salem bin\n          Sultan Al Qasimi, FIE Executive Committee member, Asian Fencing Confederation\n          President, Arab Fencing Federation President and UAE Fencing Federation\n          President; H.E. Saeed Hareb, Secretary-General of the Dubai Sports Council;\n          and H.E. Nasser Al Rahma, Vice Chairman of the Hamdan Sports Complex. The\n          Championships were declared officially open by FIE Interim President Emmanuel\n          Katsiadakis.</p>\n        <p>Each weapon (sabre, foil, epee) had three days of competition in a row, with\n          each threeday cycle including a first day of men\u2019s and women\u2019s individual\n          junior events, followed by a day of individual cadet events and ending with a\n          day of junior team events.</p>\n        <p>COVID-19 protocols at the Championships were followed to ensure safety for\n          all participants and attendees, including a mask mandate, social distancing as\n          well as regular testing. Top rankings included the following results:</p>\n        <p>SABRE</p>\n        <ul>\n          <li>Junior Men\u2019s Individual Sabre (152 fencers)<ol>\n              <li>Colin Heathcock (GER, gold)</li>\n              <li>Pietro Torre (ITA, silver)</li>\n              <li>Antonio Heathcock (GER, bronze)</li>\n              <li>Heegeun Hwang (KOR, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Women\u2019s Individual Sabre (126 fencers)<ol>\n              <li>Magda Skarbonkiewicz (USA, gold)</li>\n              <li>Honor Johnson (USA, silver)</li>\n              <li>Zaynab Dayibekova (UZB, bronze)</li>\n              <li>Sugar Katinka Battai (HUN, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Cadet Men\u2019s Individual Sabre (95 fencers)<ol>\n              <li>Zuhridden Kodirov (UZB, gold)</li>\n              <li>Colin Heathcock (GER, silver)</li>\n              <li>Cody Ji (USA, bronze)</li>\n              <li>William Morrill (USA, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Cadet Women\u2019s Individual Sabre (90 fencers)<ol>\n              <li>Magda Skarbonkiewicz (USA, gold)</li>\n              <li>Siobhan Sullivan (USA, silver)</li>\n              <li>Alejandra Manga (FRA, bronze)</li>\n              <li>Eunyu Kim (KOR, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Men\u2019s Team Sabre (34 teams)<ol>\n              <li>Italy (gold)</li>\n              <li>Romania (silver)</li>\n              <li>Egypt (bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Women\u2019s Team Sabre (27 teams)<ol>\n              <li>France (gold)</li>\n              <li>Hungary (silver)</li>\n              <li>Italy (bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <p>FOIL</p>\n        <ul>\n          <li>Junior Men\u2019s Individual Foil (180 fencers)<ol>\n              <li>Kazuki Iimura (JPN, gold)</li>\n              <li>Hyeonbhin An (KOR, silver)</li>\n              <li>Anas Anane (FRA, bronze)</li>\n              <li>Chase T. Emmer (USA, bronze</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Women\u2019s Individual Foil (148 fencers)<ol>\n              <li>Lauren Scruggs (USA, gold)</li>\n              <li>Yuzuha Takeyama (JPN, silver)</li>\n              <li>Carolina Stutchbury (GBR, bronze)</li>\n              <li>Kateryna Budenko (UKR, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Cadet Men\u2019s Individual Foil (117 fencers)<ol>\n              <li>Tit Nam Cheng (HKG, gold)</li>\n              <li>Ruben Lindner (GER, silver)</li>\n              <li>Matteo Iacomoni (ITA, bronze)</li>\n              <li>Andrew Chen (USA, bronze)</li>\n            </ol>\n          </li>\n          <li>Cadet Women\u2019s Individual Foil (104 women)<ol>\n              <li>Jessica Zi Jia Guo (CAN, gold)</li>\n              <li>Carolina Stutchbury (GBR, silver)</li>\n              <li>Rino Nagase (JPN, bronze)</li>\n              <li>Matilde Molinari (ITA, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Men\u2019s Team Foil (37 teams)<ol>\n              <li>Italy (gold)</li>\n              <li>France (silver)</li>\n              <li>Hungary (bronze</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Women\u2019s Team Foil (32 teams)<ol>\n              <li>USA (gold)</li>\n              <li>Italy (silver)</li>\n              <li>Japan (bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <p>EPEE</p>\n        <ul>\n          <li>Junior Men\u2019s Individual Epee (208 fencers)<ol>\n              <li>Zsombor Keszthelyi (HUN, gold)</li>\n              <li>Mohamed Yasseen (EGY, silver)</li>\n              <li>James Jeal (GBR, bronze)</li>\n              <li>Lino Heurlin Vazquez (FRA, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Women\u2019s Individual Epee (160 fencers)<ol>\n              <li>Hadley Husisian (USA, gold)</li>\n              <li>Nicole Feygin (ISR, silver)</li>\n              <li>Aleyna Erturk (TUR, bronze)</li>\n              <li>Ketki Ketkar (USA, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Cadet Men\u2019s Individual Epee (142 fencers)<ol>\n              <li>Samuel Imrek (USA, gold)</li>\n              <li>Alon Sarid (ISR, silver)</li>\n              <li>Fabio Mastromarino (ITA, bronze)</li>\n              <li>Maksym Perchuk (UKR, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Cadet Women\u2019s Individual Epee (109 fencers)<ol>\n              <li>Aleyna Erturk (TUR, gold)</li>\n              <li>Anna Maksymenko (UKR, silver)</li>\n              <li>Hailin Chen (HKG, bronze)</li>\n              <li>Mizuki Homma (JPN, bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Men\u2019s Team Epee (42 teams)<ol>\n              <li>Egypt (gold)</li>\n              <li>USA (silver)</li>\n              <li>France (bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <ul>\n          <li>Junior Women\u2019s Team Epee (33 teams)<ol>\n              <li>Israel (gold)</li>\n              <li>Poland (silver)</li>\n              <li>USA (bronze)</li>\n            </ol>\n          </li>\n        </ul>\n        <p>Tap here to see the GOLD MEDALLISTS\n          [Pop-up]</p>\n        <p>MEDAL TABLE</p>\n        <ol>\n          <li>USA - 6 Gold, 3 Silver, 6 Bronze - 15 Total</li>\n          <li>ITA - 2 Gold, 2 Silver, 4 Bronze - 8 Total</li>\n          <li>GER - 1 Gold, 2 Silver, 1 Bronze - 4 Total</li>\n          <li>ISR - 1 Gold, 2 Silver, 0 Bronze - 3 Total</li>\n          <li>FRA - 1 Gold, 1 Silver, 4 Bronze - 6 Total</li>\n          <li>JPN - 1 Gold, 1 Silver, 3 Bronze - 5 Total</li>\n          <li>HUN - 1 Gold, 1 Silver, 2 Bronze - 4 Total</li>\n          <li>EGY - 1 Gold, 1 Silver, 1 Bronze - 3 Total</li>\n          <li>TUR - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>\n          <li>HKG - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>\n          <li>UZB - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>\n          <li>CAN - 1 Gold, 0 Silver, 0 Bronze - 1 Total</li>\n          <li>UKR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>\n          <li>GBR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>\n          <li>KOR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>\n          <li>POL - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>\n          <li>ROU - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>\n        </ol>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim\n            .fromTo(cOf(\"39-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"39-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"39-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"39-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg39Anim.stop();\n          resetNumbers(\"39-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SP ORT  A GRAND AND SUCCESSFUL 2022 JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS IN DUBAI  DUBAI, UNITED ARAB EMIRATES 2–10 APRIL 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"40-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim\n            .fromTo(idOf(\"40-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          resetNumbers(\"40-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 2 OF 5  The 2022 Junior and Cadet Fencing World Championships have been declared a spectacular success by FIE Interim President Emmanuel Katsiadakis. The nine-day event, which included 18 individual and team events for junior and cadet men and women fencers, had the largest number of participants in its history, with 1357 fencers from 103 countries. It took place at Dubai’s impressive Hamdan Sports Complex, a world-class multi-purpose sports facility known for hosting a broad array of international championships and events.  The following shows the countries participating in the Junior and Cadet Fencing World Championships, by continental regions: Africa			13 Americas			20 Asia/Oceania		 32 Europe			38 Total			103 The official opening ceremony for the Championships featured several local dignitaries attending, including H.E. Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Minister of State for Entrepreneurship and SMEs and Chairman of the Board of Directors of the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"41-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim\n            .fromTo(idOf(\"41-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          resetNumbers(\"41-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 3 OF 5  General Sports Authority; H.E. Sheikh Salem bin Sultan Al Qasimi, FIE Executive Committee member, Asian Fencing Confederation President, Arab Fencing Federation President and UAE Fencing Federation President; H.E. Saeed Hareb, Secretary-General of the Dubai Sports Council; and H.E. Nasser Al Rahma, Vice Chairman of the Hamdan Sports Complex. The Championships were declared officially open by FIE Interim President Emmanuel Katsiadakis. Each weapon (sabre, foil, epee) had three days of competition in a row, with each threeday cycle including a first day of men’s and women’s individual junior events, followed by a day of individual cadet events and ending with a day of junior team events. COVID-19 protocols at the Championships were followed to ensure safety for all participants and attendees, including a mask mandate, social distancing as well as regular testing.  Top rankings included the following results: SABRE • Junior Men’s Individual Sabre (152 fencers) 1. Colin Heathcock (GER, gold) 2. Pietro Torre (ITA, silver) 3. Antonio Heathcock (GER, bronze) 3. Heegeun Hwang (KOR, bronze) • Junior Women’s Individual Sabre (126 fencers) 1. Magda Skarbonkiewicz (USA, gold) 2. Honor Johnson (USA, silver) 3. Zaynab Dayibekova (UZB, bronze) 3. Sugar Katinka Battai (HUN, bronze) • Cadet Men’s Individual Sabre (95 fencers) 1. Zuhridden Kodirov (UZB, gold) 2. Colin Heathcock (GER, silver) 3. Cody Ji (USA, bronze) 3. William Morrill (USA, bronze)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"42-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim\n            .fromTo(idOf(\"42-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          resetNumbers(\"42-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "FOIL • Junior Men’s Individual Foil (180 fencers) 1. Kazuki Iimura (JPN, gold) 2. Hyeonbhin An (KOR, silver) 3. Anas Anane (FRA, bronze) 3. Chase T. Emmer (USA, bronze  JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 4 OF 5  • Cadet Women’s Individual Sabre (90 fencers) 1. Magda Skarbonkiewicz (USA, gold) 2. Siobhan Sullivan (USA, silver) 3. Alejandra Manga (FRA, bronze) 3. Eunyu Kim (KOR, bronze) • Junior Men’s Team Sabre (34 teams) 1. Italy (gold) 2. Romania (silver) 3. Egypt (bronze) • Junior Women’s Team Sabre (27 teams) 1. France (gold) 2. Hungary (silver) 3. Italy (bronze)  • Junior Women’s Individual Foil (148 fencers) 1. Lauren Scruggs (USA, gold) 2. Yuzuha Takeyama (JPN, silver) 3. Carolina Stutchbury (GBR, bronze) 3. Kateryna Budenko (UKR, bronze) • Cadet Men’s Individual Foil (117 fencers) 1. Tit Nam Cheng (HKG, gold) 2. Ruben Lindner (GER, silver) 3. Matteo Iacomoni (ITA, bronze) 3. Andrew Chen (USA, bronze) • Cadet Women’s Individual Foil (104 women) 1. Jessica Zi Jia Guo (CAN, gold) 2. Carolina Stutchbury (GBR, silver) 3. Rino Nagase (JPN, bronze) 3. Matilde Molinari (ITA, bronze)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-red.png\">\n        </a>\n          \n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:655px;left:45px\" onclick=\"showOverlay('43-popups')\"\n          src=\"/120/en/static/_content/trophy-red.png\">\n        \n        <img id=\"43-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div id=\"43-popups\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/120/en/static/_content/39-popup-1.png\" alt=\"\">\n          <div class=\"contentLink\" style=\"top: 66px; left: 1030px; width: 35px; height: 35px;\" onclick=\"hideOverlay('43-popups');\"></div>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim\n            .fromTo(idOf(\"43-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n          resetNumbers(\"43-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "JUNIOR AND CADET FENCING WORLD CHAMPIONSHIPS DUBAI, UNITED ARAB EMIRATES 5 OF 5  • Junior Men’s Team Foil (37 teams) 1. Italy (gold) 2. France (silver) 3. Hungary (bronze • Junior Women’s Team Foil (32 teams) 1. USA (gold) 2. Italy (silver) 3. Japan (bronze) EPEE • Junior Men’s Individual Epee (208 fencers) 1. Zsombor Keszthelyi (HUN, gold) 2. Mohamed Yasseen (EGY, silver) 3. James Jeal (GBR, bronze) 3. Lino Heurlin Vazquez (FRA, bronze) • Junior Women’s Individual Epee (160 fencers) 1. Hadley Husisian (USA, gold) 2. Nicole Feygin (ISR, silver) 3. Aleyna Erturk (TUR, bronze) 3. Ketki Ketkar (USA, bronze)  Tap here to see the GOLD MEDALLISTS  • Cadet Men’s Individual Epee (142 fencers) 1. Samuel Imrek (USA, gold) 2. Alon Sarid (ISR, silver) 3. Fabio Mastromarino (ITA, bronze) 3. Maksym Perchuk (UKR, bronze) • Cadet Women’s Individual Epee (109 fencers) 1. Aleyna Erturk (TUR, gold) 2. Anna Maksymenko (UKR, silver) 3. Hailin Chen (HKG, bronze) 3. Mizuki Homma (JPN, bronze) • Junior Men’s Team Epee (42 teams) 1. Egypt (gold) 2. USA (silver) 3. France (bronze) • Junior Women’s Team Epee (33 teams) 1. Israel (gold) 2. Poland (silver) 3. USA (bronze) ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 277px; right: 647px; width: 175px; height: 21px;\"></div>\n        </a>\n        <!-- <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 201px; right: 697px; width: 265px; height: 21px;\"></div>\n        </a> -->\n        <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 255px; right: 685px; width: 135px; height: 21px;\"></div>\n        </a>\n        <!-- <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 157px; right: 751px; width: 209px; height: 38px;\"></div>\n        </a> -->\n      ",
    "mobileHtml": "\n        <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/44-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 45-title\" style=\"top:58px;left:65px;\" src=\"/120/en/static/_content/45-title-1.png\">\n\n        <img id=\"45-next\" class=\"halfScale pointer\" style=\"top:718px;right:-243px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-long-pink.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n        \n        <div class=\"contentLink\" onclick=\"showOverlay('45-popups')\" style=\"bottom: 385px; right: 130px; width: 55px; height: 23px;\"></div>\n\n        <div id=\"45-popups\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"45-pop-1\" class=\"halfScale 45-popup\" src=\"/120/en/static/_content/45-popup-1.png\" alt=\"\">\n          <img id=\"45-pop-2\" class=\"halfScale 45-popup\" src=\"/120/en/static/_content/45-popup-2.png\" style=\"opacity:0\" alt=\"\">\n          <div class=\"contentLink\" style=\"top:721px;left:600px;width:138px;height:48px;\"\n            onclick=\"togglePage45('45-pop-1', '45-popup');\"></div>\n          <div class=\"contentLink\" style=\"top:721px;left:738px;width:138px;height:48px;\"\n            onclick=\"togglePage45('45-pop-2', '45-popup');\"></div>\n          <div class=\"contentLink\" style=\"top: 40px; left: 1040px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('45-popups');\"></div>\n        </div>\n      ",
    "mobileHtml": "\n        <h2\n          id=\"bert-m-j-van-de-flier-ned-mh-given-royal-decoration-from-the-netherlands\">\n          Bert M.J. van de Flier (NED, MH) Given Royal Decoration from the Netherlands\n        </h2>\n        <img src=\"/120/en/static/_content/45-mobile-1.jpg\">\n        <p><strong> Lausanne, Switzerland<br>6 December 2021</strong></p>\n        <p><strong>The FIE has been informed that FIE Member of Honour and Member of the\n            FIE Fair-Play Council Bert M. J. van der Flier (NED) received a royal\n            decoration, \u201COfficer in the Order of Oranje-Nassau\u201D, from his Excellency\n            Pieter de Gooijer, the Dutch ambassador to France. The presentation took\n            place in the presence of Mr. Dominique Breton, honorary consul in Brest; Mr.\n            Guy Pennec, mayor of Plourin-les-Morlaix; and Leon Pijnappel, chairman of\n            the Royal Dutch Fencing Federation (KNAS).</strong></p>\n        <p>The decoration exceeds knighthood, one of the higher awards that may be\n          bestowed upon a civilian from the Netherlands and given to him in recognition\n          of his many years of service and dedication to Dutch, European and world\n          fencing. Over many years, Mr. van de Flier has had many roles and achievements\n          in fencing leading to his award:</p>\n        <p>Mr. van de Flier was appointed an FIE Member of Honour by the 2013 Paris\n          Congress and inducted into the FIE Hall of Fame in 2014. He served as a member\n          of the FIE Scale of Votes Commission, the Disciplinary Panel and has chaired\n          the FIE Fair-Play Council. He has been the DT president at World Championships\n          and a frequent official FIE World Cup supervisor.</p>\n        <p>Since 2012, Mr. van de Flier has worked on the International Fair Play\n          Committee (CIFP) and been its secretary-treasurer since 2015. His work led to\n          the 2017 creation of the FIE Fair-Play Council.</p>\n        <p>Royal Decoration from the Netherlands Mr. van de Flier has been a Member of\n          Honour of the KNAS since 1995 and actively involved in the organisation since\n          1978. He chaired its Technical Commission before becoming the KNAS\n          secretary-general in 1981 and interim president in 1982. He then became the\n          youngest president of the KNAS, a role he held for 12 years. After leaving the\n          board in 1995, he rejoined as secretary-general in 2010, a position he still\n          holds.</p>\n        <p>He helped establish the European Fencing Confederation in 1991 and served on\n          its board for 17 years, including being secretary-general, first\n          vice-president, treasurer and SEMI Commission president. Several world and\n          European championships have been organised in the Netherlands from 1985 to\n          1995 thanks to Mr. van de Flier\u2019s efforts, who is also credited with being\n          instrumental in helping the Airborne Trophy and Zoetermeer Trophy competitions\n          become (former) FIE World Cups in the Netherlands.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim\n            .fromTo(cOf(\"45-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"45-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        function togglePage45(show, hide) {\n          var show = idOf(show)\n          var hide = cOf(hide)\n          TweenMax.to(hide, 0.01, {opacity: 0});\n          TweenMax.to(show, 0.01, {opacity:1});\n        }\n        function onPageLeave() {\n          pg45Anim.stop();\n          resetNumbers(\"45-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "FIE  INSIDE FENCING Bert M.J. van de Flier (NED, MH) Given Royal Decoration from the Netherlands Click to read more here  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 259px; right: 22px; width: 33px; height: 154px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/46-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 47-title\" style=\"top:195px;left:65px;\" src=\"/120/en/static/_content/47-title-1.png\">\n        <img class=\"abs halfScale 47-sub\" style=\"top:388px;left:92px;\" src=\"/120/en/static/_content/47-sub-1.png\">\n        <img class=\"abs halfScale 47-line\" style=\"top:390px;left:64px;\" src=\"/120/en/static/_content/47-line-1.png\">\n        <img id=\"47-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-green.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"togo-hosts-fencing-equipment-repair-course\">Togo hosts fencing equipment\n          repair course</h2>\n        <img src=\"/120/en/static/_content/47-mobile-1.jpg\">\n        <p><strong>Lom\xE9, Togo<br>14 January 2022</strong></p>\n        <p><strong>The Togolese Fencing Federation hosted a fencing equipment repair\n            course from Dec. 14-18, 2021 with 14 trainees from four fencing leagues in\n            the region. </strong></p>\n        <p>The course, held at the request of Federation President Victor Lam\xE9ga, was\n          funded by the FIE, which provided expert instruction, equipment and tools.</p>\n        <p>Mr. Gilles Martinage (FRA), who has worked as an official armourer and\n          managed weapons control in numerous events worldwide, led the preparation and\n          training of the course.</p>\n        <p>The 14 trainees had varying levels of experience, including athletes,\n          coaches, fencing masters trained in Dakar or Algiers, athletes training to be\n          coaches, and the international referee and technical director of the Togolese\n          Federation, Mr. Koffi Kassefon.</p>\n        <p>Theoretical and informational content was provided about electrical scoring\n          systems, technical aspects of weapons operation and current equipment\n          regulations. Topics covered included fault detection, complete weapon repair\n          and assembly, verification of piste installations and proper personal gear\n          verification (e.g., lames, body wires, masks, etc.).</p>\n        <p>The course overall was interactive and hands-on, focused on developing and\n          practicing technical skills. Daily content addressed the individual interests,\n          skills and expectations of the trainees and focused on ensuring they developed\n          the ability to consistently reproduce the techniques they learned. Practical\n          exercises took place using the equipment provided by the FIE: 12 basic repair\n          kits, three armourer cases and a special kit for repairing cable spools. The\n          focus of these exercises was to effectively recondition competition weapons,\n          standardizing body wires, spool repair, managing piste cables and\n          repairing/managing scoring apparatus and associated remote controls. Trainees\n          learned to test all equipment, test and detect faults and determine proper and\n          necessary repairs and apply the repairs, including soldering, bonding wires to\n          blades and restoring metallic threads for proper conductivity.</p>\n        <p>The results of the course included trainees being able to effectively assess\n          and repair virtually all FIE competition weapons, test and repair body cords\n          and cable spools, repair remotes for scoring systems and craft cables designed\n          to connect cable spools to weapons.</p>\n        <p>When participation certificates were presented to trainees, Mr. Martinage\n          hailed their enthusiasm, outstanding work and conscientiousness throughout the\n          course. Togolese Federation President Lam\xE9ga also welcomed the \u201Cspirit of\n          cohesion\u201D that prevailed during the programme.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim\n            .fromTo(cOf(\"47-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"47-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"47-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"47-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg47Anim.stop();\n          resetNumbers(\"47-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "FIE & NATIONAL FEDER ATION NE WS  TOGO HOSTS FENCING EQUIPMENT REPAIR COURSE LOMÉ, TOGO JANUARY 14, 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-green.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-green.png\">\n        </a>\n\n        <img id=\"48-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-edge-green.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim\n            .fromTo(idOf(\"48-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n          resetNumbers(\"48-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 3  The Togolese Fencing Federation hosted a fencing equipment repair course from Dec. 14-18, 2021 with 14 trainees from four fencing leagues in the region. The course, held at the request of Federation President Victor Laméga, was funded by the FIE, which provided expert instruction, equipment and tools. Mr. Gilles Martinage (FRA), who has worked as an official armourer and managed weapons control in numerous events worldwide, led the preparation and training of the course.  The 14 trainees had varying levels of experience, including athletes, coaches, fencing masters trained in Dakar or Algiers, athletes training to be coaches, and the international referee and technical director of the Togolese Federation, Mr. Koffi Kassefon. Theoretical and informational content was provided about electrical scoring systems, technical aspects of weapons operation and current equipment regulations. Topics covered included fault detection, complete weapon repair and assembly, verification of piste installations and proper personal gear verification (e.g., lames, body wires, masks, etc.). The course overall was interactive and hands-on, focused on developing and practicing technical skills. Daily content addressed the individual interests, skills and expectations of the trainees and focused on ensuring they developed the ability to consistently reproduce the techniques they learned. Practical exercises took place using the equipment provided by the FIE: 12"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/en/static/_content/tw-green.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/en/static/_content/fb-green.png\">\n        </a>\n\n        <img id=\"49-next\" class=\"halfScale pointer\" style=\"top:647px;right:-79px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-pad-green.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim\n            .fromTo(idOf(\"49-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n          resetNumbers(\"49-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "determine proper and necessary repairs and apply the repairs, including soldering, bonding wires to blades and restoring metallic threads for proper conductivity.  FIE & NATIONAL FEDERATION NEWS 3 OF 3  The results of the course included trainees being able to effectively assess and repair virtually all FIE competition weapons, test and repair body cords and cable spools, repair remotes for scoring systems and craft cables designed to connect cable spools to weapons. basic repair kits, three armourer cases and a special kit for repairing cable spools. The focus of these exercises was to effectively recondition competition weapons, standardizing body wires, spool repair, managing piste cables and repairing/managing scoring apparatus and associated remote controls. Trainees learned to test all equipment, test and detect faults and  When participation certificates were presented to trainees, Mr. Martinage hailed their enthusiasm, outstanding work and conscientiousness throughout the course. Togolese Federation President Laméga also welcomed the “spirit of cohesion” that prevailed during the programme. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/en/static/_content/50-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 51-title\" style=\"top:67px;left:63px;\" src=\"/120/en/static/_content/51-title-1.png\">\n\n        <img id=\"51-next\" class=\"halfScale pointer\" style=\"top:718px;right:-243px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-long-orange.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div class=\"contentLink\" onclick=\"showOverlay('51-popups-1')\" style=\"bottom: 256px; right: 838px; width: 71px; height: 27px;\"></div>\n        <div class=\"contentLink\" onclick=\"showOverlay('51-popups-2')\" style=\"bottom: 500px; right: 288px; width: 51px; height: 23px;\"></div>\n\n        <div id=\"51-popups-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"51-pop-2-1\" class=\"halfScale 51-popup-2\" src=\"/120/en/static/_content/51-popup-1-1.png\" alt=\"\">\n          <div class=\"contentLink\" style=\"top: 40px; left: 1040px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('51-popups-1');\"></div>  \n        </div>\n        <div id=\"51-popups-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"51-pop-2-1\" class=\"halfScale 51-popup-2A\" src=\"/120/en/static/_content/51-popup-2-1.png\" alt=\"\">\n          <img id=\"51-pop-2-2\" class=\"halfScale 51-popup-2\" src=\"/120/en/static/_content/51-popup-2-2.png\" style=\"opacity:0\" alt=\"\">\n          <div class=\"contentLink\" style=\"top: 798px; left: 600px; width: 125px; height: 48px;\"\n            onclick=\"togglePage51('51-pop-2-1', '51-popup-2');\"></div>\n          <div class=\"contentLink\" style=\"top: 798px; left: 755px; width: 125px; height: 48px;\"\n            onclick=\"togglePage51('51-pop-2-2', '51-popup-2');\"></div>\n          <div class=\"contentLink\" style=\"top: 40px; left: 1040px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('51-popups-2');\"></div>\n        </div>\n      ",
    "mobileHtml": "\n        <h2 id=\"fie-news\">FIE NEWS</h2>\n        <p><strong>1<br>IOC Athlete365 Career+ \u201CPower-Up\u2019\u2019 workshop</strong></p>\n        <img src=\"/120/en/static/_content/51-mobile-1.jpg\">\n        <p><strong>Prior to the start of the 2022 Junior and Cadet Fencing World\n            Championships in Dubai, United Arab Emirates, an IOC Athlete365 Career+\n            \u2018\u2019Power-Up\u2019\u2019 workshop was held for fencers taking part in an official FIE\n            training camp.</strong></p>\n        <p>The workshop was led by three-time Olympian and FIE digital communication\n          manager Maria Ntanou, with 16 fencers participating from 16 countries.</p>\n        <p>The half-day workshop covered several modules, such as how to identify your\n          strengths and values.</p>\n        <p>The workshop teaches that no matter what stage your career is in, it is\n          important to take time to reflect and evaluate who you are and what you want\n          out of life. Finding what your superpowers are and what truly motivates and\n          drives you will help in all aspects of your career and life.</p>\n        <p>This first session focused on self-reflection and activities among athletes\u2019\n          groups to answer questions like: \u201CWhat is great about me?\u201D, \u201CWhat could I be\n          better at?\u201D and \u201CWhat is important to me?\u201D</p>\n        <p>At the end of the session fencers were able to distinguish three of their top\n          personality trait strengths and three areas they could develop further.</p>\n        <p><strong>2<br>FIE Supports April 6 International Day of Sport for Development\n            and Peace at Dubai Junior and Cadet Fencing World Championships</strong></p>\n        <img src=\"/120/en/static/_content/51-mobile-2.jpg\">\n        <p><strong>Today is the International Day of Sport for Development and Peace\n            (IDSDP), designated by the United Nations General Assembly, a movement\n            supported by the FIE.</strong></p>\n        <p>Each year, on April 6, the world of sport highlights the unique power of\n          sport in supporting people and communities to overcome adversity and\n          contribute significantly as a crucial enabler of sustainable development. It\n          recognises sports activities and their positive impact on peace and harmony in\n          the co-existence of communities worldwide.</p>\n        <p>The 2022 IDSDP theme is \u201CSecuring a Sustainable and Peaceful Future for All:\n          The Contribution of Sport\u201D. Using sport as a key component to ensure a\n          sustainable future for mankind, the current focus is on climate change and\n          diminishing greenhouse gas emissions.</p>\n        <p>At the Junior and Cadet Fencing World Championships, taking place from April\n          2 to 10 in Dubai, United Arab Emirates, athletes were briefed on the IDSDP and\n          as is the organisation\u2019s hallmark symbol, asked to hold white cards.</p>\n        <p>They are a reference to the yellow and red penalty cards in the sporting\n          world, and since 2014 a #WhiteCard is a symbol created by the organisation\n          \u201CPeace and Sport\u201D, representing the positive power of sport for peace and\n          social inclusion. International teen athletes participating in the Junior and\n          Cadet Fencing World Championships from all three fencing weapons (epee, foil,\n          sabre) and both genders provided their thoughts on the April 6 initiative:</p>\n        <p>\u201C Sports is a way to bond with something we all have in common. There are\n          thousands of fencers here who are setting-aside their differences to compete.\n          Of course, we cannot do that without peace.\u201D\n          Jakob Lars Kristmannson (ISL)</p>\n        <p>\u201C Peace and sport unifies people even though there\u2019s competition. There\u2019s a\n          level of sportsmanship and understanding, so it\u2019s a great way to bring people\n          together.\u201D\n          Sanojah Gilkes (BAR)</p>\n        <p>\u201C Sports like fencing bring people together; they want to compete but also\n          want to show companionship. As a sportsman, even though you are fighting, you\n          want to be sure be peaceful when not in competition, to bring each other\n          closer and provide feedback to one another.\u201D\n          Daniella Weng Yan Tang (SGP)</p>\n        <p>According to the Peace and Sport organisation, \u201CThrough a #WhiteCard, each of\n          us can advocate on the unique power of sport for social development and peace\n          and share a story on how sport supported us to overcome challenges.\u201D</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax();\n          pg51Anim\n            .fromTo(cOf(\"51-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"51-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        function togglePage51(show, hide) {\n          var show = idOf(show)\n          var hide = cOf(hide)\n          TweenMax.to(hide, 0.01, {opacity: 0});\n          TweenMax.to(show, 0.01, {opacity:1});\n        }\n        function onPageLeave() {\n          pg51Anim.stop();\n          resetNumbers(\"51-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "NE WS  FIE NEWS  WWW.FIE.ORG  2  FIE Supports International Day of Sport for Development and Peace See more here.  1  IOC Athlete365 Career+ “Power-Up’’ workshop See more here.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:jason@jiangfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 76px; right: 352px; width: 235px; height: 19px;\"></div>\n        </a>\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 97px; right: 377px; width: 211px; height: 17px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/52-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 53-title\" style=\"top:67px;left:58px;\" src=\"/120/en/static/_content/53-title-1.png\">\n\n        <img id=\"53-next\" class=\"halfScale pointer\" style=\"top:719px;right:-184px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/en/static/_content/arrow-long-navy.png\">\n        \n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div id=\"53-1\" class=\"abs noOverflow 53-div\" style=\"top:299px; left: 65px; height: 520px; width: 810px; display: block;\">\n          <img id=\"53-text-1a\" class=\"halfScale 53-text-1\" style=\"top:0px;left:0px;\"\n            src=\"/120/en/static/_content/53-text-1-1.png\">\n          <img id=\"53-text-1b\" class=\"halfScale 53-text-1\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/en/static/_content/53-text-1-2.png\">\n          <div id=\"53-btn-1a\" class=\"abs halfScale pointer 53-btn-1\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-1a', '53-btn-1', '53-text-1a', '53-text-1')\"></div>\n          <div id=\"53-btn-1b\" class=\"abs halfScale pointer 53-btn-1\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-1b', '53-btn-1', '53-text-1b', '53-text-1')\"></div>\n        </div>\n        \n        <div id=\"53-2\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-2a\" class=\"halfScale 53-text-2\" style=\"top:0px;left:0px;\"\n            src=\"/120/en/static/_content/53-text-2-1.png\">\n          <img id=\"53-text-2b\" class=\"halfScale 53-text-2\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/en/static/_content/53-text-2-2.png\">\n          <div id=\"53-btn-2a\" class=\"abs halfScale pointer 53-btn-2\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-2a', '53-btn-2', '53-text-2a', '53-text-2')\"></div>\n          <div id=\"53-btn-2b\" class=\"abs halfScale pointer 53-btn-2\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-2b', '53-btn-2', '53-text-2b', '53-text-2')\"></div>\n        </div>\n        \n        <div id=\"53-3\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-3a\" class=\"halfScale 53-text-3\" style=\"top:0px;left:0px;\"\n            src=\"/120/en/static/_content/53-text-3-1.png\">\n          <img id=\"53-text-3b\" class=\"halfScale 53-text-3\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/en/static/_content/53-text-3-2.png\">\n          <div id=\"53-btn-3a\" class=\"abs halfScale pointer 53-btn-3\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-3a', '53-btn-3', '53-text-3a', '53-text-3')\"></div>\n          <div id=\"53-btn-3b\" class=\"abs halfScale pointer 53-btn-3\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-3b', '53-btn-3', '53-text-3b', '53-text-3')\"></div>\n        </div>\n        \n        <div id=\"53-4\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-4a\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px;\"\n            src=\"/120/en/static/_content/53-text-4-1.png\">\n          <img id=\"53-text-4b\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/en/static/_content/53-text-4-2.png\">\n          <img id=\"53-text-4c\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/en/static/_content/53-text-4-3.png\">\n          <div id=\"53-btn-4a\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-4a', '53-btn-4', '53-text-4a', '53-text-4')\"></div>\n          <div id=\"53-btn-4b\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-4b', '53-btn-4', '53-text-4b', '53-text-4')\"></div>\n          <div id=\"53-btn-4c\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-4c', '53-btn-4', '53-text-4c', '53-text-4')\"></div>\n        </div>\n        \n        <div id=\"53-5\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-5a\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px;\"\n            src=\"/120/en/static/_content/53-text-5-1.png\">\n          <img id=\"53-text-5b\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px; opacity:0;;\"\n            src=\"/120/en/static/_content/53-text-5-2.png\">\n          <img id=\"53-text-5c\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px; opacity:0;;\"\n            src=\"/120/en/static/_content/53-text-5-3.png\">\n          <div id=\"53-btn-5a\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-5a', '53-btn-5', '53-text-5a', '53-text-5')\"></div>\n          <div id=\"53-btn-5b\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-5b', '53-btn-5', '53-text-5b', '53-text-5')\"></div>\n          <div id=\"53-btn-5c\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-5c', '53-btn-5', '53-text-5c', '53-text-5')\"></div>\n        </div>\n        \n        <div id=\"53-6\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-6a\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px;\"\n            src=\"/120/en/static/_content/53-text-6-1.png\">\n          <img id=\"53-text-6b\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/en/static/_content/53-text-6-2.png\">\n          <img id=\"53-text-6c\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/en/static/_content/53-text-6-3.png\">\n          <div id=\"53-btn-6a\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-6a', '53-btn-6', '53-text-6a', '53-text-6')\"></div>\n          <div id=\"53-btn-6b\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-6b', '53-btn-6', '53-text-6b', '53-text-6')\"></div>\n          <div id=\"53-btn-6c\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-6c', '53-btn-6', '53-text-6c', '53-text-6')\"></div>\n        </div>\n        \n        <img id=\"53-cta-1\" class=\"halfScale pointer 53-btn\" style=\"top:258px;left:869px;transform:scale(0.506,0.52);\"\n          onclick=\"pg53Toggle('53-1', '53-cta-1');\" src=\"/120/en/static/_content/53-name-1.png\">\n        <img id=\"53-cta-2\" class=\"halfScale pointer 53-btn\" style=\"top:325px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-2', '53-cta-2');\" src=\"/120/en/static/_content/53-name-2.png\">\n        <img id=\"53-cta-3\" class=\"halfScale pointer 53-btn\" style=\"top:393px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-3', '53-cta-3');\" src=\"/120/en/static/_content/53-name-3.png\">\n        <img id=\"53-cta-4\" class=\"halfScale pointer 53-btn\" style=\"top:461px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-4', '53-cta-4');\" src=\"/120/en/static/_content/53-name-4.png\">\n        <img id=\"53-cta-5\" class=\"halfScale pointer 53-btn\" style=\"top:528px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-5', '53-cta-5');\" src=\"/120/en/static/_content/53-name-5.png\">\n        <img id=\"53-cta-6\" class=\"halfScale pointer 53-btn\" style=\"top:595px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-6', '53-cta-6');\" src=\"/120/en/static/_content/53-name-6.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"obituaries\">Obituaries</h2>\n        <p><strong>1<br>JAHANGIR SAFAROV (AZE)</strong></p>\n        <img src=\"/120/en/static/_content/53-mobile-1.png\">\n        <p><strong>The FIE is saddened to learn of the passing of Jahangir Safarov (AZE)\n            on 12 November.</strong></p>\n        <p>He was a coach of the Azerbaijan national fencing team as well as a national\n          referee. He was born on 9 March 1968. Safarov began fencing at age 10. He\n          became a medallist at numerous USSR competitions and participated in World and\n          European Championships and was named a USSR Master of Sports in 1985.</p>\n        <p>He became a coach of the Azerbaijan national team in 2001, producing several\n          national champions as well as medallists at international and regional\n          competitions, and was the head coach for cadet women\u2019s sabre. Safarov\u2019s\n          student, Zarifa Huseynova, took the bronze medal in individual cadet women\u2019s\n          sabre at the 2021 Cairo Junior and Cadet Fencing World Championships. His son,\n          Javanshir Safarov, whom he also coached, took silver in men\u2019s sabre at the\n          Tehran Junior World Cup in December 2013.</p>\n        <p>On behalf of the world fencing family, the FIE offers sincere condolences to\n          Jahangir Safarov\u2019s family and friends, the Azerbaijan Fencing Federation and\n          the European Fencing Confederation, and we express our deepest sympathy during\n          this difficult time.</p>\n        <p><strong>2<br>ALEX ORBAN (USA)</strong></p>\n        <img src=\"/120/en/static/_content/53-mobile-2.png\">\n        <p><strong>The FIE is saddened to learn of the passing of Alex Orban (USA) on 2\n            December at age 82, a three-time Olympic sabreur.</strong></p>\n        <p>He was born on August 25, 1939 in Budapest, Hungary and began fencing when he\n          was 14. By age 16 he was the youngest fencer ever to have achieved a\n          first-class ranking in Hungary and labelled the \u201Ccoming star of the Magyar\n          squads\u201D.</p>\n        <p>Mr. Orban moved to the USA and after serving three years in the U.S.\n          military, he trained and competed in fencing. He became a member of the U.S.\n          Olympic fencing team at the 1968 (Mexico City), 1972 (Munich) and 1976\n          (Montreal) Olympic Games.</p>\n        <p>He was U.S. national sabre champion in 1965 and every year from 1969 to 1972,\n          and individual sabre champion at the 1971 Pan American Games in Cali,\n          Colombia. Mr.Orban also won men\u2019s team sabre silver medals at the Pan American\n          Games in 1971 and 1975 (Mexico City). He was the first U.S. sabre fencer to\n          win an international \u201CA\u201D-rated event in 1968 in Lodz, Poland.</p>\n        <p>Mr. Orban was inducted into the USA Fencing Hall of Fame in 1999.</p>\n        <p>On behalf of the world fencing family, the FIE offers sincere condolences to\n          Alex Orban\u2019s family and friends, USA Fencing and the Pan American Fencing\n          Confederation, and we express our deepest sympathy during this difficult time.\n        </p>\n        <p><strong>3<br>ALI YOUSSEF HUSSAIN (KUW, MH)</strong></p>\n        <img src=\"/120/en/static/_content/53-mobile-3.png\">\n        <p><strong>The FIE is saddened to learn of the passing on 26 December of Ali\n            Youssef Hussain (KUW), an FIE Member of Honour and member of the Hall of\n            Fame. He was born in 1938.</strong></p>\n        <p>A former member of the FIE Executive Committee (2001-2008), Mr. Hussain was\n          made a Member of Honour by the Congress in 2008. From 1985 to 2004, he was a\n          member of the FIE Propaganda Commission (now named the Promotion,\n          Communication and Marketing Commission).</p>\n        <p>In 1977, he was elected as a member of the Kuwait Amateur Fencing\n          Association, serving over time as their president for eight years as well as a\n          member of the Board of Directors and Technical Committee, and the\n          organisation\u2019s manager of products. Mr. Hussain was a member of the Kuwait\n          National Olympic Committee Board of Directors, serving as its\n          secretary-treasurer from 1994 to 2014.</p>\n        <p>Involved in several sports from a young age, Mr. Hussain was for many years a\n          member of the Yarmouk Sports Club beginning in 1965, the year it was founded.\n          He was a member of its board of directors for 10 years and served as its\n          secretary-general and president.</p>\n        <p>Among various educational programmes, Mr. Hussain attended an academic\n          international Olympic course in sports management in 1987. He also studied\n          management and sports science under the supervision of the Arab Sports\n          Federation, which as of 1988 enabled him to pursue his career in sports\n          administration.</p>\n        <p>The FIE offers its sincere condolences and expresses its deepest sympathy to\n          Ali Youssef Hussain\u2019s family and friends, the Kuwait Fencing Amateur Fencing\n          Association and the Asian Fencing Confederation.</p>\n        <p><strong>4<br>OLGA ORBAN-SZABOV (ROU)</strong></p>\n        <img src=\"/120/en/static/_content/53-mobile-4.png\">\n        <p><strong>The FIE is saddened to learn of the passing on January 5 of Olga\n            Orban- Szabo (ROU), multiple-time Olympic medallist and world champion and a\n            member of the FIE Hall of Fame. </strong></p>\n        <p>Born on October 9, 1938 in Cluj, Ms. Szabo was the first Olympic medallist\n          and world champion for Romania, and competed in five Olympic Games (Melbourne\n          1956, Rome 1960, Tokyo 1964, Mexico City 1968 and Munich 1972). She earned her\n          first Olympic medal, a silver in women\u2019s individual foil, in Melbourne, and\n          then a bronze in women\u2019s team foil in both the Mexico City and Munich Games.\n        </p>\n        <p>She became individual women\u2019s foil world champion at the 1962 Buenos Aires\n          World Championships. As part of the Romanian women\u2019s foil team (including\n          Maria Vicol, Ileana Gyulai, Ecaterina Stahl and Ana Pascu), she took a gold\n          medal at the 1969 Havana World Championships, another first for her country.\n        </p>\n        <p>In all, Ms. Orban-Szabo earned 11 Olympic and World Championships medals in\n          women\u2019s foil, including three from the Olympic Games and eight at the World\n          Championships between 1961 and 1970. Prior to that, she was a junior world\n          silver medallist in 1959.</p>\n        <p>She also won three medals at the Universiade, including individual silver and\n          team gold in 1961 and team silver in 1965. As member of the army club \u201CSteaua\n          Bucarest\u201D, she won the Romanian national championship seven times, and was\n          awarded the national title of \u201CEmeritus Master of Sport\u201D as well as numerous\n          Romanian orders and titles. She graduated from the Babes-Bolyai University in\n          Cluj-Napoca and was also a fencing master. Following her retirement from\n          competition in 1972, she worked as a youth fencing coach at her club in\n          Bucharest.</p>\n        <p>\u201CShe was a distinguished Lady of the Romanian fencing team\u201D, stated Marius\n          Florea, Romanian Federation President. \u201CThe Romanian Fencing Federation would\n          like to express its deep gratitude for Mrs. Olga Orban-Szabo\u2019s contribution to\n          the foundation of the Romanian fencing family.\u201D The FIE offers its sincere\n          condolences and expresses its deepest sympathy to Olga Orban-Szabo\u2019s family\n          and friends, the Romanian Fencing Federation and the European Fencing\n          Confederation.</p>\n        <p><strong>5<br>JOSE VALARINHO (POR)</strong></p>\n        <img src=\"/120/en/static/_content/53-mobile-5.png\">\n        <p><strong>The FIE is saddened to learn of the passing of Jose Valarinho (POR),\n            member of the FIE Hall of Fame, on March 30, 2022, at the age of 87. He was\n            a member of the FIE Disciplinary Commission from 1996 to 2004.</strong></p>\n        <p>He was awarded a special FIE gold medal three times for his academic work on\n          fencing as well as organising the 1988 FIE Congress in Madeira and the 2002\n          Lisbon World Championships. He also received the Olympic Order of the\n          Portuguese Olympic Committee and the Medal for Sports Merits by the Portuguese\n          government.</p>\n        <p>Mr. Valarinho was president of the Portuguese Fencing Federation for two\n          terms beginning in 1992. He joined the organisation in 1969 as president of\n          the Technical Commission, and over several decades he had a significant impact\n          on the growth and development of fencing in Portugal. He participated in a\n          \u201CPlan for the Development of Sports\u201D with a special program, \u201C500 Foils\u201D, and\n          worked to support Portugal becoming more active in international fencing.</p>\n        <p>Mr. Valarinho took part in organising the first European Championships in\n          Lisbon, 1983, as well as multiple other continental and world competitions\n          held in Portugal during the 1980s and 1990s. His vision for Portuguese\n          becoming a strong participant in world fencing was realised fully when his\n          country\u2019s men\u2019s foil team won the gold medal at the 2000 European\n          Championships in Madeira. After his departure from the presidency, he\n          successfully organised the 2002 Lisbon Fencing World Championships.</p>\n        <p>Having a traditional Portuguese military education, Mr. Valarinho ultimately\n          became an Army officer, and it was during his schooling where he first\n          experienced fencing along with becoming a skilled equestrian. He graduated\n          with honours as a ma\xEEtre at the Military Sports Center in Mafra, where he was\n          a competitive fencer and took part in the 1959 Universiade as a member of the\n          men\u2019s sabre team. Following school, he became a fencing master, specialised in\n          recruiting and developing young fencers. He was the author of two books on the\n          history of Portuguese fencing and was in the process of preparing a third\n          edition.</p>\n        <p>\u201CHe was a fencer to his dying day\u201D, said his son, Frederico Valarinho, who\n          has been a member of the Portuguese Fencing Federation since 2006. The FIE\n          extends its sincere condolences to Jose Valarinho\u2019s family and friends, the\n          Portuguese Fencing Federation and the European Fencing Confederation. We\n          express our deepest sympathy to them during this difficult time.</p>\n        <p><strong>ANA PASCU (ROU, MH)</strong></p>\n        <img src=\"/120/en/static/_content/53-mobile-6.png\">\n        <p>Elected in 2000, Ms. Pascu served as a member of the FIE Executive Committee,\n          including being vice president from 2004 to 2021. Prior to that, she was a\n          member of the FIE Rules Commission from 1984 to 1988</p>\n        <p>The FIE is deeply saddened to learn of the passing in Bucharest on April 6,\n          2022, of Ms. Ana Pascu (ROU), FIE Member of Honour and Hall of Fame member.\n          She was born on September 22, 1944 and of the FIE Refereeing Commission from\n          1988 to 1996. She was also an FIE international referee in foil and epee.</p>\n        <p>She holds the record as the longest-serving president of a Romanian Fencing\n          Federation. From 1982 to 2013, Ms. Pascu headed the Federation, contributing\n          to the sporting achievements of Romanian fencers who won 134 medals during her\n          tenure, including nine at the Olympic Games, 57 at the World Championships and\n          68 at the European Championships. Following her retirement as president, she\n          was appointed honorary president of the Romanian Fencing Federation.</p>\n        <p>She was also vice president of the Romanian Olympic and Sports Committee. As\n          an athlete, Ms. Pascu was a five-time Olympic foilist, and in team foil she\n          won a bronze medal at the 1968 and 1972 Olympic Games and the gold medal at\n          the 1969 Havana World Championships. In individual foil, she won the Junior\n          World Championships in 1963 as well as the bronze medal at the 1971 World\n          Championships. As part of the Romanian Women\u2019s Foil Team, she won the team\n          foil silver medal at the 1970 World Championships and bronze medals at the\n          1961, 1967, 1971, 1973, 1974 and 1975 World Championships. In 1961 and 1965,\n          her team won gold and silver, respectively, at the World University Games\n          (\u201CUniversiade\u201D).</p>\n        <p>Ms. Pascu also had a career as a fencing coach and physical education teacher\n          until 1982, having earned a doctorate in physical education and sport. Her\n          doctoral thesis was titled The Strategy for Enhancing Sports Preparation in\n          Competitions. She also held a \u201CDoctor Honoris Causa\u201D from Vasile Goldis\n          University in Romania. She authored numerous scientific and sports\n          publications and was awarded several titles and decorations, including the\n          National Order of Merit in the rank of Officer and Knight. </p>\n        <p>Ms. Pascu dedicated her entire life to fencing, fencers, Romanian Fencing and\n          the FIE, and the many successes resulting from this are testament to her\n          incredible talent and passion for our sport. In the words of Emmanuel\n          Katsiadakis, FIE Interim President, \u201CShe tirelessly, generously and with\n          infinite kindness helped, supported and motivated all those who sought her\n          help and advice. She was an outstanding mentor and role model for athletes,\n          officials and leaders in fencing, as well as for girls and women in sport. The\n          fencing family has lost a great lady and an emblematic personality with rare\n          and invaluable human and professional qualities. She will remain in our\n          memories, in our hearts and in our history.\u201D</p>\n        <p>The FIE extends its sincere condolences for their loss to Ms. Pascu\u2019s sister\n          Nicoleta, her family and friends, the Romanian Fencing Federation and the\n          European Fencing Confederation, and expresses its deepest sympathy during this\n          difficult time.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim\n            .to(idOf(\"53-1\"), 0.3,{display: 'block'}, 0)\n            .fromTo(cOf(\"53-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"53-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function pg53Toggle(id, btn) {\n          var ele = idOf(id)\n          var but = idOf(btn)\n          TweenMax.to(cOf(\"53-div\"), 0.01, {display: 'none'});\n          TweenMax.to(cOf(\"53-btn\"), 0.01, {opacity: 0});\n          TweenMax.to(ele, 0.1, {display: 'block'});\n          TweenMax.to(but, 0.1, {opacity: 1});\n        }\n        \n        function togglePage(id, klass, text, texttwo) {\n          var ele = idOf(id)\n          var but = cOf(klass)\n          var txt = idOf(text)\n          var txt2 = cOf(texttwo)\n          TweenMax.to(but, 0.01, {opacity: 0});\n          TweenMax.to(txt2, 0.01, {opacity: 0});\n          TweenMax.to(ele, 0.01, {opacity:1});\n          TweenMax.to(txt, 0.01, {opacity:1});\n        }\n        \n        function onPageLeave(){\n          pg53Toggle('53-text-1', '53-cta-1');\n          togglePage('53-btn-1', '53-btn-2', '53-text-1', '53-text-1');\n          pg53Anim.stop();\n          resetNumbers(\"53-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "REMEMBR ANCE  OBITUARIES JAHANGIR SAFAROV  JAHANGIR SAFAROV (AZE) and European Championships and was named a USSR Master of Sports in 1985.  The FIE is saddened to learn of the passing of Jahangir Safarov (AZE) on 12 November. He was a coach of the Azerbaijan national fencing team as well as a national referee. He was born on 9 March 1968. Safarov began fencing at age 10. He became a medallist at numerous USSR competitions and participated in World  He became a coach of the Azerbaijan national team in 2001, producing several national champions as well as medallists at international and regional competitions, and was the head coach for cadet women’s sabre. Safarov’s student, Zarifa Huseynova, took the bronze medal in individual cadet women’s sabre at the 2021 Cairo Junior and Cadet Fencing World Championships. His son, Javanshir Safarov, whom he also  ALEX ORBAN  ALI YOUSSEF HUSSAIN  OLGA ORBAN-SZABO  JOSE VALARINHO  ANA PASCU  s Click Above to View  1  2  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 186px; right: 599px; width: 228px; height: 38px;\"></div>\n        </a>\n        <a href=\"mailto:sales@gfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 186px; right: 340px; width: 236px; height: 38px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <img src=\"/120/en/static/_content/54-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n        \n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) { \n          return e.className = 'addContentLinkThree'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": [{
    title: "Escrime XXI No. 120",
    link: "Escrime XXI No. 120",
    cssClass: "cover mobile-p1",
    hideInMenu: false,
    pageLinks: [{
      index: 0,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 2,
      subIndex: 0
    }]
  }, {
    title: "Comex",
    link: "Comex",
    cssClass: "blue",
    hideInMenu: false,
    pageLinks: [{
      index: 4,
      subIndex: 0
    }]
  }, {
    title: "Foreword",
    link: "Foreword",
    cssClass: "darkblue",
    hideInMenu: false,
    pageLinks: [{
      index: 5,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 6,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Tashkent",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 7,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Orleans",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 9,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 12,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Tallinn",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 13,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Bern",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 16,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 18,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | St Maur",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 19,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Paris",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 21,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 23,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Poznan",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 24,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Tbilisi",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 26,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 29,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Plovdiv",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 30,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Doha",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 32,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Budapest",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 34,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 37,
      subIndex: 0
    }]
  }, {
    title: "Sport",
    link: "Sport | Dubai",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 38,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 43,
      subIndex: 0
    }]
  }, {
    title: "FIE",
    link: "Inside Fencing",
    cssClass: "pink",
    hideInMenu: false,
    pageLinks: [{
      index: 44,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 45,
      subIndex: 0
    }]
  }, {
    title: "FIE & National Federation News",
    link: "FIE & National Federation News | Togo",
    cssClass: "green",
    hideInMenu: false,
    pageLinks: [{
      index: 46,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 49,
      subIndex: 0
    }]
  }, {
    title: "News",
    link: "FIE News",
    cssClass: "orange",
    hideInMenu: false,
    pageLinks: [{
      index: 50,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 51,
      subIndex: 0
    }]
  }, {
    title: "Rememberance",
    link: "Obituaries",
    cssClass: "grey",
    hideInMenu: false,
    pageLinks: [{
      index: 52,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 53,
      subIndex: 0
    }]
  }],
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-199016370-44',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TKcf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UhHM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UrMh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UxE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aKuC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kxw3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXGk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vvnJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e486f168afc5d30ffbf7.js